
window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.innerHTML="";
 linkmsg.style.visibility="hidden";
 sizemsg.style.visibility="hidden";
 opmsg.style.visibility="hidden";
}
//カート中身リセット
function cartReset(){
    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_haba.innerHTML=""; 
    cart_outside.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color.innerHTML="";
    cart_option.innerHTML="";
    cart_opprice.innerHTML="";
    linkmsg.style.visibility="hidden";
}
//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intHaba == ""){document.getElementById("outside").innerHTML = "　";}
    if (intDepth == ""){document.getElementById("outside").innerHTML = "　";}
    if (intHeight == ""){document.getElementById("outside").innerHTML = "　";}
    if (intDepth==""||intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intHaba < 40 || intHaba > 150){document.getElementById("sizemsg").innerHTML = "<p>※ 天板幅40cm未満・天板幅151cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 30 || intDepth > 90){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行30cm未満・奥行91cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHaba < 90 && intDepth > intHaba){document.getElementById("sizemsg").innerHTML = "<p>※ 天板幅を超える奥行はオーダー不可です </p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 40 && intHeight > 72){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ73cm～90cmは奥行40cm未満のオーダー不可です </p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 37 || intHeight > 90){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ37cm未満・高さ90cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
    
    //外寸幅表示用 外寸幅＝天板幅＋2×(高さ÷5.6713)
String.prototype.splice = function(idx, rem, s) {
    return (this.slice(0, idx) + s + this.slice(idx + Math.abs(rem)));
};
    var valueHaba = intHaba*10;
    var valueHeight = intHeight*10;
    var intOutside = "約"+Math.ceil(valueHaba+2*(valueHeight/5.6713));
    intOutside=intOutside.splice(-1, 0, ".");
    document.getElementById("outside").innerHTML=intOutside;
    /*
    var intOutside=document.getElementById("outside").innerHTML = "約"+Math.ceil(valueHaba+2*(valueHeight/5.6713));
    旧高さ固定値
    if (intHeight == 42){document.getElementById("outside").innerHTML = "約"+(parseInt(intHaba)+15);}
    else if (intHeight == 60){document.getElementById("outside").innerHTML = "約"+(parseInt(intHaba)+21.5);}
    else if (intHeight == 72){document.getElementById("outside").innerHTML = "約"+(parseInt(intHaba)+27);}
    else if (intHeight == 90){document.getElementById("outside").innerHTML = "約"+(parseInt(intHaba)+30);}
    var intOutside=document.getElementById("outside").innerHTML; if(intOutside == "約NaN"){document.getElementById("outside").innerHTML = "　";} return false;*/
    
 sizemsg.style.visibility="hidden";
}

function changeOp(){
    cartReset();
}

//サイズオーダー
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,thick,color,form,price){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.thick=thick;this.color=color;this.form=form;this.price=price;}
function searchURL(strHaba,strDepth,strHeight,strThick,strColor,strForm){
var strErr;
var intHaba=document.getElementById("haba").value
var intDepth=document.getElementById("depth").value
var intHeight=document.getElementById("height").value

//天板幅チェック
if (intHaba < 40){
 strErr="天板幅40cm未満は";
}else if (intHaba > 150){
  strErr="天板幅151cm以上は";}
//奥行チェック
if (intDepth < 30){
 strErr="奥行30cm未満は";
}else if (intDepth > 90){
  strErr="奥行90cm以上は";}
//幅×奥行チェック
if (intHaba < 90 && intDepth > intHaba){
 strErr="天板幅を超える奥行は";}
//高さ×奥行チェック
if (intDepth < 40 && intHeight > 72){
 strErr="高さ73cm～90cmは奥行40cm未満の";}
//不可文言
if(strErr){document.getElementById("price").value="";
return strErr+"オーダー不可です。";}


//幅サイズ成形
if (strHaba.slice(-1)>=1 && strHaba.slice(-1)<=9){strHaba=parseInt(strHaba.slice(0,strHaba.length-1)) + 1 +"0";}

//奥行サイズ成形
if (strDepth.slice(-1)>=1 && strDepth.slice(-1)<=9){strDepth=parseInt(strDepth.slice(0,strDepth.length-1)) + 1 +"0";}

//高さサイズ成形
switch(intHeight != null){
  case intHeight <= 42: //高さ42cm以下のとき
    strHeight = 42;
    break;
  case intHeight <= 60: //高さ60cm以下のとき
    strHeight = 60;
    break;
  case intHeight <= 72: //高さ72cm以下のとき
    strHeight = 72;
    break;
  case intHeight <= 90: //高さ90cm以下のとき
    strHeight = 90;
    break;
}

//リストから価格取得
switch(true){
  default:
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
console.log(goods[i].url+"/"+goods[i].price);
return goods[i].price+"/"+goods[i].url;}}
  break;  
}
return false;
}

/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strThick,strColor,strForm){
switch(true){
 default:
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;  
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("colortype") ;
var idOption = document.getElementsByName("option") ;
var strColor = "";
var strOption = "";
var strOutside = "";
var strThick="40";
var strForm="normal";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,3)=="kme" ){
         strColor = idColor[i].id.slice(0,3);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}
var total = 0;
for ( c = idOption.length; c--; ) {
 if ( idOption[c].checked ) {
     total++;
     if( strOption == "" ) {
         strOption = idOption[c].id;
         var valueOption = idOption[c].value;
     }else if( strOption != "" ) {
         var valueOption = valueOption+"、"+idOption[c].value;
     }
 }
}
if(typeof valueOption=== "undefined"){
     valueOption="オプション無し";
 }




if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
//document.getElementById("choice2").value="外寸幅：約" +strOutside+"cm/"
document.getElementById("choice3").value=strDepth+"cm"
document.getElementById("choice4").value=strHeight+"cm"
document.getElementById("choice5").value=valueColor
document.getElementById("choice6").value=valueOption
//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strThick,strColor,strForm);
//抗菌kme個別ページアップされたら条件変更
if(!comcode=="" && valueOption=="オプション無し" && strColor!="kme"){
  if(valueColor=="強化紙オーク" || valueColor=="強化紙ブラックウッド"){
    var target=document.getElementById("linkmsg");
    linkmsg.style.visibility="visible";
    target.innerHTML=valueColor+"は別注色のため金額が異なります。";
  }
  else {
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
  }
}

var url=searchURL(strHaba,strDepth,strHeight,strThick,strColor,strForm);


if(!url){
alert("幅、奥行を選んでください");
return false;
}
var strCode=url.substr(url.lastIndexOf("/"));
url=url.replace(strCode,"");
strCode="/"+strCode.substring(4,11)

var intUnit;
if (isNaN(url)==false){
 if(total>0){
     total=total*1000;
 }
 document.getElementById("choice8").value=total
 
 intUnit=(parseInt(url)+total)/1000;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_outside.innerHTML=strOutside;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 cart_opprice.innerHTML=total;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice7").value="見積もり金額："+(parseInt(url)+total);
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
// var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;
 var choice6=document.frm.choice6.value;
 var choice7=document.frm.choice7.value;
 var choice8=document.frm.choice8.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000a53659","40","30","42","40","wood","normal","14000");
goods[1] =new setGoods("0000a53664","50","30","42","40","wood","normal","15000");
goods[2] =new setGoods("0000a53669","60","30","42","40","wood","normal","16000");
goods[3] =new setGoods("0000a53674","70","30","42","40","wood","normal","17000");
goods[4] =new setGoods("0000a53679","80","30","42","40","wood","normal","17000");
goods[5] =new setGoods("0000a53684","90","30","42","40","wood","normal","18000");
goods[6] =new setGoods("0000a53689","100","30","42","40","wood","normal","20000");
goods[7] =new setGoods("0000a53694","110","30","42","40","wood","normal","22000");
goods[8] =new setGoods("0000a53699","120","30","42","40","wood","normal","22000");
goods[9] =new setGoods("0000a53704","130","30","42","40","wood","normal","23000");
goods[10] =new setGoods("0000a53709","140","30","42","40","wood","normal","24000");
goods[11] =new setGoods("0000a53714","150","30","42","40","wood","normal","27000");
goods[12] =new setGoods("0000a53719","50","40","42","40","wood","normal","19000");
goods[13] =new setGoods("0000a53724","60","40","42","40","wood","normal","19000");
goods[14] =new setGoods("0000a53729","70","40","42","40","wood","normal","20000");
goods[15] =new setGoods("0000a53734","80","40","42","40","wood","normal","21000");
goods[16] =new setGoods("0000a53739","90","40","42","40","wood","normal","21000");
goods[17] =new setGoods("0000a53744","100","40","42","40","wood","normal","26000");
goods[18] =new setGoods("0000a53749","110","40","42","40","wood","normal","26000");
goods[19] =new setGoods("0000a53754","120","40","42","40","wood","normal","26000");
goods[20] =new setGoods("0000a53759","130","40","42","40","wood","normal","27000");
goods[21] =new setGoods("0000a53764","140","40","42","40","wood","normal","29000");
goods[22] =new setGoods("0000a53769","150","40","42","40","wood","normal","31000");
goods[23] =new setGoods("0000a53774","60","50","42","40","wood","normal","22000");
goods[24] =new setGoods("0000a53779","70","50","42","40","wood","normal","27000");
goods[25] =new setGoods("0000a53784","80","50","42","40","wood","normal","28000");
goods[26] =new setGoods("0000a53789","90","50","42","40","wood","normal","29000");
goods[27] =new setGoods("0000a53794","100","50","42","40","wood","normal","31000");
goods[28] =new setGoods("0000a53799","110","50","42","40","wood","normal","32000");
goods[29] =new setGoods("0000a53804","120","50","42","40","wood","normal","32000");
goods[30] =new setGoods("0000a53809","130","50","42","40","wood","normal","33000");
goods[31] =new setGoods("0000a53814","140","50","42","40","wood","normal","35000");
goods[32] =new setGoods("0000a53819","150","50","42","40","wood","normal","36000");
goods[33] =new setGoods("0000a53824","70","60","42","40","wood","normal","29000");
goods[34] =new setGoods("0000a53829","80","60","42","40","wood","normal","29000");
goods[35] =new setGoods("0000a53834","90","60","42","40","wood","normal","31000");
goods[36] =new setGoods("0000a53839","100","60","42","40","wood","normal","33000");
goods[37] =new setGoods("0000a53844","110","60","42","40","wood","normal","34000");
goods[38] =new setGoods("0000a53849","120","60","42","40","wood","normal","35000");
goods[39] =new setGoods("0000a53854","130","60","42","40","wood","normal","36000");
goods[40] =new setGoods("0000a53859","140","60","42","40","wood","normal","37000");
goods[41] =new setGoods("0000a53864","150","60","42","40","wood","normal","39000");
goods[42] =new setGoods("0000a53869","80","70","42","40","wood","normal","35000");
goods[43] =new setGoods("0000a53874","90","70","42","40","wood","normal","36000");
goods[44] =new setGoods("0000a53879","100","70","42","40","wood","normal","43000");
goods[45] =new setGoods("0000a53884","110","70","42","40","wood","normal","44000");
goods[46] =new setGoods("0000a53889","120","70","42","40","wood","normal","44000");
goods[47] =new setGoods("0000a53894","130","70","42","40","wood","normal","45000");
goods[48] =new setGoods("0000a53899","140","70","42","40","wood","normal","45000");
goods[49] =new setGoods("0000a53904","150","70","42","40","wood","normal","46000");
goods[50] =new setGoods("0000a53909","90","80","42","40","wood","normal","36000");
goods[51] =new setGoods("0000a53914","100","80","42","40","wood","normal","44000");
goods[52] =new setGoods("0000a53919","110","80","42","40","wood","normal","44000");
goods[53] =new setGoods("0000a53924","120","80","42","40","wood","normal","44000");
goods[54] =new setGoods("0000a53929","130","80","42","40","wood","normal","45000");
goods[55] =new setGoods("0000a53934","140","80","42","40","wood","normal","45000");
goods[56] =new setGoods("0000a53939","150","80","42","40","wood","normal","49000");
goods[57] =new setGoods("0000a53944","100","90","42","40","wood","normal","49000");
goods[58] =new setGoods("0000a53949","110","90","42","40","wood","normal","49000");
goods[59] =new setGoods("0000a53954","120","90","42","40","wood","normal","49000");
goods[60] =new setGoods("0000a53959","130","90","42","40","wood","normal","49000");
goods[61] =new setGoods("0000a53964","140","90","42","40","wood","normal","52000");
goods[62] =new setGoods("0000a53969","150","90","42","40","wood","normal","52000");
goods[63] =new setGoods("0000a53974","40","40","42","40","wood","normal","19000");
goods[64] =new setGoods("0000a53979","50","50","42","40","wood","normal","22000");
goods[65] =new setGoods("0000a53984","60","60","42","40","wood","normal","28000");
goods[66] =new setGoods("0000a53989","70","70","42","40","wood","normal","35000");
goods[67] =new setGoods("0000a53994","80","80","42","40","wood","normal","36000");
goods[68] =new setGoods("0000a53999","90","90","42","40","wood","normal","40000");
goods[69] =new setGoods("0000a54004","40","30","60","40","wood","normal","16000");
goods[70] =new setGoods("0000a54009","50","30","60","40","wood","normal","17000");
goods[71] =new setGoods("0000a54014","60","30","60","40","wood","normal","18000");
goods[72] =new setGoods("0000a54019","70","30","60","40","wood","normal","19000");
goods[73] =new setGoods("0000a54024","80","30","60","40","wood","normal","19000");
goods[74] =new setGoods("0000a54029","90","30","60","40","wood","normal","20000");
goods[75] =new setGoods("0000a54034","100","30","60","40","wood","normal","22000");
goods[76] =new setGoods("0000a54039","110","30","60","40","wood","normal","24000");
goods[77] =new setGoods("0000a54044","120","30","60","40","wood","normal","24000");
goods[78] =new setGoods("0000a54049","130","30","60","40","wood","normal","24000");
goods[79] =new setGoods("0000a54054","140","30","60","40","wood","normal","27000");
goods[80] =new setGoods("0000a54059","150","30","60","40","wood","normal","28000");
goods[81] =new setGoods("0000a54064","50","40","60","40","wood","normal","21000");
goods[82] =new setGoods("0000a54069","60","40","60","40","wood","normal","21000");
goods[83] =new setGoods("0000a54074","70","40","60","40","wood","normal","22000");
goods[84] =new setGoods("0000a54079","80","40","60","40","wood","normal","22000");
goods[85] =new setGoods("0000a54084","90","40","60","40","wood","normal","26000");
goods[86] =new setGoods("0000a54089","100","40","60","40","wood","normal","28000");
goods[87] =new setGoods("0000a54094","110","40","60","40","wood","normal","28000");
goods[88] =new setGoods("0000a54099","120","40","60","40","wood","normal","28000");
goods[89] =new setGoods("0000a54104","130","40","60","40","wood","normal","29000");
goods[90] =new setGoods("0000a54109","140","40","60","40","wood","normal","31000");
goods[91] =new setGoods("0000a54114","150","40","60","40","wood","normal","32000");
goods[92] =new setGoods("0000a54119","60","50","60","40","wood","normal","26000");
goods[93] =new setGoods("0000a54124","70","50","60","40","wood","normal","28000");
goods[94] =new setGoods("0000a54129","80","50","60","40","wood","normal","29000");
goods[95] =new setGoods("0000a54134","90","50","60","40","wood","normal","31000");
goods[96] =new setGoods("0000a54139","100","50","60","40","wood","normal","33000");

goods[97] =new setGoods("0000a54144","110","50","60","40","wood","normal","34000");
goods[98] =new setGoods("0000a54149","120","50","60","40","wood","normal","34000");
goods[99] =new setGoods("0000a54154","130","50","60","40","wood","normal","36000");
goods[100] =new setGoods("0000a54159","140","50","60","40","wood","normal","37000");
goods[101] =new setGoods("0000a54164","150","50","60","40","wood","normal","39000");
goods[102] =new setGoods("0000a54169","70","60","60","40","wood","normal","31000");
goods[103] =new setGoods("0000a54174","80","60","60","40","wood","normal","32000");
goods[104] =new setGoods("0000a54179","90","60","60","40","wood","normal","33000");
goods[105] =new setGoods("0000a54184","100","60","60","40","wood","normal","35000");
goods[106] =new setGoods("0000a54189","110","60","60","40","wood","normal","36000");
goods[107] =new setGoods("0000a54194","120","60","60","40","wood","normal","37000");
goods[108] =new setGoods("0000a54199","130","60","60","40","wood","normal","39000");
goods[109] =new setGoods("0000a54204","140","60","60","40","wood","normal","40000");
goods[110] =new setGoods("0000a54209","150","60","60","40","wood","normal","42000");
goods[111] =new setGoods("0000a54214","80","70","60","40","wood","normal","39000");
goods[112] =new setGoods("0000a54219","90","70","60","40","wood","normal","40000");
goods[113] =new setGoods("0000a54224","100","70","60","40","wood","normal","46000");
goods[114] =new setGoods("0000a54229","110","70","60","40","wood","normal","46000");
goods[115] =new setGoods("0000a54234","120","70","60","40","wood","normal","46000");
goods[116] =new setGoods("0000a54239","130","70","60","40","wood","normal","47000");
goods[117] =new setGoods("0000a54244","140","70","60","40","wood","normal","48000");
goods[118] =new setGoods("0000a54249","150","70","60","40","wood","normal","49000");
goods[119] =new setGoods("0000a54254","90","80","60","40","wood","normal","40000");
goods[120] =new setGoods("0000a54259","100","80","60","40","wood","normal","47000");
goods[121] =new setGoods("0000a54264","110","80","60","40","wood","normal","46000");
goods[122] =new setGoods("0000a54269","120","80","60","40","wood","normal","47000");
goods[123] =new setGoods("0000a54274","130","80","60","40","wood","normal","47000");
goods[124] =new setGoods("0000a54279","140","80","60","40","wood","normal","49000");
goods[125] =new setGoods("0000a54284","150","80","60","40","wood","normal","52000");
goods[126] =new setGoods("0000a54289","100","90","60","40","wood","normal","51000");
goods[127] =new setGoods("0000a54294","110","90","60","40","wood","normal","51000");
goods[128] =new setGoods("0000a54299","120","90","60","40","wood","normal","51000");
goods[129] =new setGoods("0000a54304","130","90","60","40","wood","normal","51000");
goods[130] =new setGoods("0000a54309","140","90","60","40","wood","normal","55000");
goods[131] =new setGoods("0000a54314","150","90","60","40","wood","normal","55000");
goods[132] =new setGoods("0000a54319","40","40","60","40","wood","normal","21000");
goods[133] =new setGoods("0000a54324","50","50","60","40","wood","normal","26000");
goods[134] =new setGoods("0000a54329","60","60","60","40","wood","normal","29000");
goods[135] =new setGoods("0000a54334","70","70","60","40","wood","normal","39000");
goods[136] =new setGoods("0000a54339","80","80","60","40","wood","normal","40000");
goods[137] =new setGoods("0000a54344","90","90","60","40","wood","normal","44000");
goods[138] =new setGoods("0000a54349","40","30","72","40","wood","normal","18000");
goods[139] =new setGoods("0000a54354","50","30","72","40","wood","normal","19000");
goods[140] =new setGoods("0000a54359","60","30","72","40","wood","normal","20000");
goods[141] =new setGoods("0000a54364","70","30","72","40","wood","normal","21000");
goods[142] =new setGoods("0000a54369","80","30","72","40","wood","normal","22000");
goods[143] =new setGoods("0000a54374","90","30","72","40","wood","normal","22000");
goods[144] =new setGoods("0000a54379","100","30","72","40","wood","normal","27000");
goods[145] =new setGoods("0000a54384","110","30","72","40","wood","normal","27000");
goods[146] =new setGoods("0000a54389","120","30","72","40","wood","normal","27000");
goods[147] =new setGoods("0000a54394","130","30","72","40","wood","normal","28000");
goods[148] =new setGoods("0000a54399","140","30","72","40","wood","normal","29000");
goods[149] =new setGoods("0000a54404","150","30","72","40","wood","normal","31000");
goods[150] =new setGoods("0000a54409","50","40","72","40","wood","normal","26000");
goods[151] =new setGoods("0000a54414","60","40","72","40","wood","normal","26000");
goods[152] =new setGoods("0000a54419","70","40","72","40","wood","normal","27000");
goods[153] =new setGoods("0000a54424","80","40","72","40","wood","normal","27000");
goods[154] =new setGoods("0000a54429","90","40","72","40","wood","normal","28000");
goods[155] =new setGoods("0000a54434","100","40","72","40","wood","normal","29000");
goods[156] =new setGoods("0000a54439","110","40","72","40","wood","normal","31000");
goods[157] =new setGoods("0000a54444","120","40","72","40","wood","normal","31000");
goods[158] =new setGoods("0000a54449","130","40","72","40","wood","normal","31000");
goods[159] =new setGoods("0000a54454","140","40","72","40","wood","normal","34000");
goods[160] =new setGoods("0000a54459","150","40","72","40","wood","normal","34000");
goods[161] =new setGoods("0000a54464","60","50","72","40","wood","normal","29000");
goods[162] =new setGoods("0000a54469","70","50","72","40","wood","normal","30000");
goods[163] =new setGoods("0000a54474","80","50","72","40","wood","normal","32000");
goods[164] =new setGoods("0000a54479","90","50","72","40","wood","normal","33000");
goods[165] =new setGoods("0000a54484","100","50","72","40","wood","normal","36000");
goods[166] =new setGoods("0000a54489","110","50","72","40","wood","normal","36000");
goods[167] =new setGoods("0000a54494","120","50","72","40","wood","normal","38000");
goods[168] =new setGoods("0000a54499","130","50","72","40","wood","normal","39000");
goods[169] =new setGoods("0000a54504","140","50","72","40","wood","normal","40000");
goods[170] =new setGoods("0000a54509","150","50","72","40","wood","normal","42000");
goods[171] =new setGoods("0000a54514","70","60","72","40","wood","normal","34000");
goods[172] =new setGoods("0000a54519","80","60","72","40","wood","normal","35000");
goods[173] =new setGoods("0000a54524","90","60","72","40","wood","normal","36000");
goods[174] =new setGoods("0000a54529","100","60","72","40","wood","normal","39000");
goods[175] =new setGoods("0000a54534","110","60","72","40","wood","normal","40000");
goods[176] =new setGoods("0000a54539","120","60","72","40","wood","normal","42000");
goods[177] =new setGoods("0000a54544","130","60","72","40","wood","normal","42000");
goods[178] =new setGoods("0000a54549","140","60","72","40","wood","normal","44000");
goods[179] =new setGoods("0000a54554","150","60","72","40","wood","normal","45000");
goods[180] =new setGoods("0000a54559","80","70","72","40","wood","normal","45000");
goods[181] =new setGoods("0000a54564","90","70","72","40","wood","normal","45000");
goods[182] =new setGoods("0000a54569","100","70","72","40","wood","normal","50000");
goods[183] =new setGoods("0000a54574","110","70","72","40","wood","normal","50000");
goods[184] =new setGoods("0000a54579","120","70","72","40","wood","normal","50000");
goods[185] =new setGoods("0000a54584","130","70","72","40","wood","normal","51000");
goods[186] =new setGoods("0000a54589","140","70","72","40","wood","normal","53000");
goods[187] =new setGoods("0000a54594","150","70","72","40","wood","normal","55000");
goods[188] =new setGoods("0000a54599","90","80","72","40","wood","normal","45000");
goods[189] =new setGoods("0000a54604","100","80","72","40","wood","normal","51000");
goods[190] =new setGoods("0000a54609","110","80","72","40","wood","normal","51000");
goods[191] =new setGoods("0000a54614","120","80","72","40","wood","normal","51000");
goods[192] =new setGoods("0000a54619","130","80","72","40","wood","normal","51000");
goods[193] =new setGoods("0000a54624","140","80","72","40","wood","normal","54000");
goods[194] =new setGoods("0000a54629","150","80","72","40","wood","normal","57000");
goods[195] =new setGoods("0000a54634","100","90","72","40","wood","normal","55000");
goods[196] =new setGoods("0000a54639","110","90","72","40","wood","normal","55000");
goods[197] =new setGoods("0000a54644","120","90","72","40","wood","normal","55000");
goods[198] =new setGoods("0000a54649","130","90","72","40","wood","normal","56000");
goods[199] =new setGoods("0000a54654","140","90","72","40","wood","normal","58000");
goods[200] =new setGoods("0000a54659","150","90","72","40","wood","normal","58000");
goods[201] =new setGoods("0000a54664","40","40","72","40","wood","normal","26000");
goods[202] =new setGoods("0000a54669","50","50","72","40","wood","normal","29000");
goods[203] =new setGoods("0000a54674","60","60","72","40","wood","normal","32000");
goods[204] =new setGoods("0000a54679","70","70","72","40","wood","normal","44000");
goods[205] =new setGoods("0000a54684","80","80","72","40","wood","normal","44000");
goods[206] =new setGoods("0000a54689","90","90","72","40","wood","normal","47000");
goods[207] =new setGoods("0000a54694","50","40","90","40","wood","normal","28000");
goods[208] =new setGoods("0000a54699","60","40","90","40","wood","normal","28000");
goods[209] =new setGoods("0000a54704","70","40","90","40","wood","normal","29000");
goods[210] =new setGoods("0000a54709","80","40","90","40","wood","normal","29000");
goods[211] =new setGoods("0000a54714","90","40","90","40","wood","normal","29000");
goods[212] =new setGoods("0000a54719","100","40","90","40","wood","normal","32000");
goods[213] =new setGoods("0000a54724","110","40","90","40","wood","normal","33000");
goods[214] =new setGoods("0000a54729","120","40","90","40","wood","normal","33000");
goods[215] =new setGoods("0000a54734","130","40","90","40","wood","normal","33000");
goods[216] =new setGoods("0000a54739","140","40","90","40","wood","normal","36000");
goods[217] =new setGoods("0000a54744","150","40","90","40","wood","normal","36000");
goods[218] =new setGoods("0000a54749","60","50","90","40","wood","normal","32000");
goods[219] =new setGoods("0000a54754","70","50","90","40","wood","normal","34000");
goods[220] =new setGoods("0000a54759","80","50","90","40","wood","normal","35000");
goods[221] =new setGoods("0000a54764","90","50","90","40","wood","normal","35000");
goods[222] =new setGoods("0000a54769","100","50","90","40","wood","normal","39000");
goods[223] =new setGoods("0000a54774","110","50","90","40","wood","normal","39000");
goods[224] =new setGoods("0000a54779","120","50","90","40","wood","normal","39000");
goods[225] =new setGoods("0000a54784","130","50","90","40","wood","normal","42000");
goods[226] =new setGoods("0000a54789","140","50","90","40","wood","normal","43000");
goods[227] =new setGoods("0000a54794","150","50","90","40","wood","normal","44000");
goods[228] =new setGoods("0000a54799","70","60","90","40","wood","normal","35000");
goods[229] =new setGoods("0000a54804","80","60","90","40","wood","normal","38000");
goods[230] =new setGoods("0000a54809","90","60","90","40","wood","normal","38000");
goods[231] =new setGoods("0000a54814","100","60","90","40","wood","normal","42000");
goods[232] =new setGoods("0000a54819","110","60","90","40","wood","normal","42000");
goods[233] =new setGoods("0000a54824","120","60","90","40","wood","normal","44000");
goods[234] =new setGoods("0000a54829","130","60","90","40","wood","normal","44000");
goods[235] =new setGoods("0000a54834","140","60","90","40","wood","normal","45000");
goods[236] =new setGoods("0000a54839","150","60","90","40","wood","normal","45000");
goods[237] =new setGoods("0000a54844","80","70","90","40","wood","normal","49000");
goods[238] =new setGoods("0000a54849","90","70","90","40","wood","normal","49000");
goods[239] =new setGoods("0000a54854","100","70","90","40","wood","normal","54000");
goods[240] =new setGoods("0000a54859","110","70","90","40","wood","normal","55000");
goods[241] =new setGoods("0000a54864","120","70","90","40","wood","normal","56000");
goods[242] =new setGoods("0000a54869","130","70","90","40","wood","normal","56000");
goods[243] =new setGoods("0000a54874","140","70","90","40","wood","normal","56000");
goods[244] =new setGoods("0000a54879","150","70","90","40","wood","normal","56000");
goods[245] =new setGoods("0000a54884","90","80","90","40","wood","normal","49000");
goods[246] =new setGoods("0000a54889","100","80","90","40","wood","normal","55000");
goods[247] =new setGoods("0000a54894","110","80","90","40","wood","normal","56000");
goods[248] =new setGoods("0000a54899","120","80","90","40","wood","normal","56000");
goods[249] =new setGoods("0000a54904","130","80","90","40","wood","normal","56000");
goods[250] =new setGoods("0000a54909","140","80","90","40","wood","normal","56000");
goods[251] =new setGoods("0000a54914","150","80","90","40","wood","normal","59000");
goods[252] =new setGoods("0000a54919","100","90","90","40","wood","normal","56000");
goods[253] =new setGoods("0000a54924","110","90","90","40","wood","normal","56000");
goods[254] =new setGoods("0000a54929","120","90","90","40","wood","normal","56000");
goods[255] =new setGoods("0000a54934","130","90","90","40","wood","normal","56000");
goods[256] =new setGoods("0000a54939","140","90","90","40","wood","normal","59000");
goods[257] =new setGoods("0000a54944","150","90","90","40","wood","normal","59000");
goods[258] =new setGoods("0000a54949","40","40","90","40","wood","normal","28000");
goods[259] =new setGoods("0000a54954","50","50","90","40","wood","normal","32000");
goods[260] =new setGoods("0000a54959","60","60","90","40","wood","normal","35000");
goods[261] =new setGoods("0000a54964","70","70","90","40","wood","normal","49000");
goods[262] =new setGoods("0000a54969","80","80","90","40","wood","normal","49000");
goods[263] =new setGoods("0000a54974","90","90","90","40","wood","normal","51000");
goods[264] =new setGoods("0000a57524","40","30","42","40","nail","normal","30000");
goods[265] =new setGoods("0000a57525","50","30","42","40","nail","normal","32000");
goods[266] =new setGoods("0000a57526","60","30","42","40","nail","normal","32000");
goods[267] =new setGoods("0000a57527","70","30","42","40","nail","normal","35000");
goods[268] =new setGoods("0000a57528","80","30","42","40","nail","normal","37000");
goods[269] =new setGoods("0000a57529","90","30","42","40","nail","normal","38000");
goods[270] =new setGoods("0000a57530","100","30","42","40","nail","normal","42000");
goods[271] =new setGoods("0000a57531","110","30","42","40","nail","normal","46000");
goods[272] =new setGoods("0000a57532","120","30","42","40","nail","normal","49000");
goods[273] =new setGoods("0000a57533","130","30","42","40","nail","normal","49000");
goods[274] =new setGoods("0000a57534","140","30","42","40","nail","normal","49000");
goods[275] =new setGoods("0000a57535","150","30","42","40","nail","normal","51000");
goods[276] =new setGoods("0000a57536","50","40","42","40","nail","normal","40000");
goods[277] =new setGoods("0000a57537","60","40","42","40","nail","normal","41000");
goods[278] =new setGoods("0000a57538","70","40","42","40","nail","normal","43000");
goods[279] =new setGoods("0000a57539","80","40","42","40","nail","normal","44000");
goods[280] =new setGoods("0000a57540","90","40","42","40","nail","normal","46000");
goods[281] =new setGoods("0000a57541","100","40","42","40","nail","normal","55000");
goods[282] =new setGoods("0000a57542","110","40","42","40","nail","normal","57000");
goods[283] =new setGoods("0000a57543","120","40","42","40","nail","normal","59000");
goods[284] =new setGoods("0000a57544","130","40","42","40","nail","normal","60000");
goods[285] =new setGoods("0000a57545","140","40","42","40","nail","normal","61000");
goods[286] =new setGoods("0000a57546","150","40","42","40","nail","normal","61000");
goods[287] =new setGoods("0000a57547","60","50","42","40","nail","normal","57000");
goods[288] =new setGoods("0000a57548","70","50","42","40","nail","normal","62000");
goods[289] =new setGoods("0000a57549","80","50","42","40","nail","normal","64000");
goods[290] =new setGoods("0000a57550","90","50","42","40","nail","normal","66000");
goods[291] =new setGoods("0000a57551","100","50","42","40","nail","normal","80000");
goods[292] =new setGoods("0000a57552","110","50","42","40","nail","normal","82000");
goods[293] =new setGoods("0000a57553","120","50","42","40","nail","normal","87000");
goods[294] =new setGoods("0000a57554","130","50","42","40","nail","normal","88000");
goods[295] =new setGoods("0000a57555","140","50","42","40","nail","normal","88000");
goods[296] =new setGoods("0000a57556","150","50","42","40","nail","normal","88000");
goods[297] =new setGoods("0000a57557","70","60","42","40","nail","normal","66000");
goods[298] =new setGoods("0000a57558","80","60","42","40","nail","normal","68000");
goods[299] =new setGoods("0000a57559","90","60","42","40","nail","normal","69000");
goods[300] =new setGoods("0000a57560","100","60","42","40","nail","normal","84000");
goods[301] =new setGoods("0000a57561","110","60","42","40","nail","normal","87000");
goods[302] =new setGoods("0000a57562","120","60","42","40","nail","normal","92000");
goods[303] =new setGoods("0000a57563","130","60","42","40","nail","normal","92000");
goods[304] =new setGoods("0000a57564","140","60","42","40","nail","normal","92000");
goods[305] =new setGoods("0000a57565","150","60","42","40","nail","normal","92000");
goods[306] =new setGoods("0000a57566","80","70","42","40","nail","normal","70000");
goods[307] =new setGoods("0000a57567","90","70","42","40","nail","normal","72000");
goods[308] =new setGoods("0000a57568","100","70","42","40","nail","normal","90000");
goods[309] =new setGoods("0000a57569","110","70","42","40","nail","normal","90000");
goods[310] =new setGoods("0000a57570","120","70","42","40","nail","normal","94000");
goods[311] =new setGoods("0000a57571","130","70","42","40","nail","normal","94000");
goods[312] =new setGoods("0000a57572","140","70","42","40","nail","normal","95000");
goods[313] =new setGoods("0000a57573","150","70","42","40","nail","normal","95000");
goods[314] =new setGoods("0000a57574","90","80","42","40","nail","normal","72000");
goods[315] =new setGoods("0000a57575","100","80","42","40","nail","normal","91000");
goods[316] =new setGoods("0000a57576","110","80","42","40","nail","normal","91000");
goods[317] =new setGoods("0000a57577","120","80","42","40","nail","normal","94000");
goods[318] =new setGoods("0000a57578","130","80","42","40","nail","normal","95000");
goods[319] =new setGoods("0000a57579","140","80","42","40","nail","normal","95000");
goods[320] =new setGoods("0000a57580","150","80","42","40","nail","normal","98000");
goods[321] =new setGoods("0000a57581","100","90","42","40","nail","normal","91000");
goods[322] =new setGoods("0000a57582","110","90","42","40","nail","normal","91000");
goods[323] =new setGoods("0000a57583","120","90","42","40","nail","normal","95000");
goods[324] =new setGoods("0000a57584","130","90","42","40","nail","normal","95000");
goods[325] =new setGoods("0000a57585","140","90","42","40","nail","normal","98000");
goods[326] =new setGoods("0000a57586","150","90","42","40","nail","normal","98000");
goods[327] =new setGoods("0000a57587","40","40","42","40","nail","normal","38000");
goods[328] =new setGoods("0000a57588","50","50","42","40","nail","normal","55000");
goods[329] =new setGoods("0000a57589","60","60","42","40","nail","normal","60000");
goods[330] =new setGoods("0000a57590","70","70","42","40","nail","normal","69000");
goods[331] =new setGoods("0000a57591","80","80","42","40","nail","normal","70000");
goods[332] =new setGoods("0000a57592","90","90","42","40","nail","normal","73000");
goods[333] =new setGoods("0000a57593","40","30","60","40","nail","normal","35000");
goods[334] =new setGoods("0000a57594","50","30","60","40","nail","normal","38000");
goods[335] =new setGoods("0000a57595","60","30","60","40","nail","normal","38000");
goods[336] =new setGoods("0000a57596","70","30","60","40","nail","normal","40000");
goods[337] =new setGoods("0000a57597","80","30","60","40","nail","normal","41000");
goods[338] =new setGoods("0000a57598","90","30","60","40","nail","normal","42000");
goods[339] =new setGoods("0000a57599","100","30","60","40","nail","normal","48000");
goods[340] =new setGoods("0000a57600","110","30","60","40","nail","normal","50000");
goods[341] =new setGoods("0000a57601","120","30","60","40","nail","normal","54000");
goods[342] =new setGoods("0000a57602","130","30","60","40","nail","normal","54000");
goods[343] =new setGoods("0000a57603","140","30","60","40","nail","normal","54000");
goods[344] =new setGoods("0000a57604","150","30","60","40","nail","normal","55000");
goods[345] =new setGoods("0000a57605","50","40","60","40","nail","normal","44000");
goods[346] =new setGoods("0000a57606","60","40","60","40","nail","normal","46000");
goods[347] =new setGoods("0000a57607","70","40","60","40","nail","normal","49000");
goods[348] =new setGoods("0000a57608","80","40","60","40","nail","normal","49000");
goods[349] =new setGoods("0000a57609","90","40","60","40","nail","normal","51000");
goods[350] =new setGoods("0000a57610","100","40","60","40","nail","normal","59000");
goods[351] =new setGoods("0000a57611","110","40","60","40","nail","normal","61000");
goods[352] =new setGoods("0000a57612","120","40","60","40","nail","normal","65000");
goods[353] =new setGoods("0000a57613","130","40","60","40","nail","normal","65000");
goods[354] =new setGoods("0000a57614","140","40","60","40","nail","normal","66000");
goods[355] =new setGoods("0000a57615","150","40","60","40","nail","normal","66000");
goods[356] =new setGoods("0000a57616","60","50","60","40","nail","normal","63000");
goods[357] =new setGoods("0000a57617","70","50","60","40","nail","normal","70000");
goods[358] =new setGoods("0000a57618","80","50","60","40","nail","normal","71000");
goods[359] =new setGoods("0000a57619","90","50","60","40","nail","normal","73000");
goods[360] =new setGoods("0000a57620","100","50","60","40","nail","normal","88000");
goods[361] =new setGoods("0000a57621","110","50","60","40","nail","normal","90000");
goods[362] =new setGoods("0000a57622","120","50","60","40","nail","normal","93000");
goods[363] =new setGoods("0000a57623","130","50","60","40","nail","normal","94000");
goods[364] =new setGoods("0000a57624","140","50","60","40","nail","normal","95000");
goods[365] =new setGoods("0000a57625","150","50","60","40","nail","normal","95000");
goods[366] =new setGoods("0000a57626","70","60","60","40","nail","normal","74000");
goods[367] =new setGoods("0000a57627","80","60","60","40","nail","normal","76000");
goods[368] =new setGoods("0000a57628","90","60","60","40","nail","normal","77000");
goods[369] =new setGoods("0000a57629","100","60","60","40","nail","normal","91000");
goods[370] =new setGoods("0000a57630","110","60","60","40","nail","normal","93000");
goods[371] =new setGoods("0000a57631","120","60","60","40","nail","normal","100000");
goods[372] =new setGoods("0000a57632","130","60","60","40","nail","normal","100000");
goods[373] =new setGoods("0000a57633","140","60","60","40","nail","normal","100000");
goods[374] =new setGoods("0000a57634","150","60","60","40","nail","normal","100000");
goods[375] =new setGoods("0000a57635","80","70","60","40","nail","normal","78000");
goods[376] =new setGoods("0000a57636","90","70","60","40","nail","normal","80000");
goods[377] =new setGoods("0000a57637","100","70","60","40","nail","normal","98000");
goods[378] =new setGoods("0000a57638","110","70","60","40","nail","normal","98000");
goods[379] =new setGoods("0000a57639","120","70","60","40","nail","normal","102000");
goods[380] =new setGoods("0000a57640","130","70","60","40","nail","normal","103000");
goods[381] =new setGoods("0000a57641","140","70","60","40","nail","normal","103000");
goods[382] =new setGoods("0000a57642","150","70","60","40","nail","normal","103000");
goods[383] =new setGoods("0000a57643","90","80","60","40","nail","normal","80000");
goods[384] =new setGoods("0000a57644","100","80","60","40","nail","normal","99000");
goods[385] =new setGoods("0000a57645","110","80","60","40","nail","normal","100000");
goods[386] =new setGoods("0000a57646","120","80","60","40","nail","normal","103000");
goods[387] =new setGoods("0000a57647","130","80","60","40","nail","normal","103000");
goods[388] =new setGoods("0000a57648","140","80","60","40","nail","normal","103000");
goods[389] =new setGoods("0000a57649","150","80","60","40","nail","normal","105000");
goods[390] =new setGoods("0000a57650","100","90","60","40","nail","normal","100000");
goods[391] =new setGoods("0000a57651","110","90","60","40","nail","normal","102000");
goods[392] =new setGoods("0000a57652","120","90","60","40","nail","normal","103000");
goods[393] =new setGoods("0000a57653","130","90","60","40","nail","normal","103000");
goods[394] =new setGoods("0000a57654","140","90","60","40","nail","normal","105000");
goods[395] =new setGoods("0000a57655","150","90","60","40","nail","normal","105000");
goods[396] =new setGoods("0000a57656","40","40","60","40","nail","normal","42000");
goods[397] =new setGoods("0000a57657","50","50","60","40","nail","normal","62000");
goods[398] =new setGoods("0000a57658","60","60","60","40","nail","normal","66000");
goods[399] =new setGoods("0000a57659","70","70","60","40","nail","normal","77000");
goods[400] =new setGoods("0000a57660","80","80","60","40","nail","normal","78000");
goods[401] =new setGoods("0000a57661","90","90","60","40","nail","normal","81000");
goods[402] =new setGoods("0000a57662","40","30","72","40","nail","normal","42000");
goods[403] =new setGoods("0000a57663","50","30","72","40","nail","normal","43000");
goods[404] =new setGoods("0000a57664","60","30","72","40","nail","normal","44000");
goods[405] =new setGoods("0000a57665","70","30","72","40","nail","normal","47000");
goods[406] =new setGoods("0000a57666","80","30","72","40","nail","normal","48000");
goods[407] =new setGoods("0000a57667","90","30","72","40","nail","normal","49000");
goods[408] =new setGoods("0000a57668","100","30","72","40","nail","normal","54000");
goods[409] =new setGoods("0000a57669","110","30","72","40","nail","normal","57000");
goods[410] =new setGoods("0000a57670","120","30","72","40","nail","normal","60000");
goods[411] =new setGoods("0000a57671","130","30","72","40","nail","normal","60000");
goods[412] =new setGoods("0000a57672","140","30","72","40","nail","normal","60000");
goods[413] =new setGoods("0000a57673","150","30","72","40","nail","normal","61000");
goods[414] =new setGoods("0000a57674","50","40","72","40","nail","normal","53000");
goods[415] =new setGoods("0000a57675","60","40","72","40","nail","normal","53000");
goods[416] =new setGoods("0000a57676","70","40","72","40","nail","normal","57000");
goods[417] =new setGoods("0000a57677","80","40","72","40","nail","normal","58000");
goods[418] =new setGoods("0000a57678","90","40","72","40","nail","normal","60000");
goods[419] =new setGoods("0000a57679","100","40","72","40","nail","normal","68000");
goods[420] =new setGoods("0000a57680","110","40","72","40","nail","normal","69000");
goods[421] =new setGoods("0000a57681","120","40","72","40","nail","normal","72000");
goods[422] =new setGoods("0000a57682","130","40","72","40","nail","normal","72000");
goods[423] =new setGoods("0000a57683","140","40","72","40","nail","normal","75000");
goods[424] =new setGoods("0000a57684","150","40","72","40","nail","normal","75000");
goods[425] =new setGoods("0000a57685","60","50","72","40","nail","normal","76000");
goods[426] =new setGoods("0000a57686","70","50","72","40","nail","normal","82000");
goods[427] =new setGoods("0000a57687","80","50","72","40","nail","normal","84000");
goods[428] =new setGoods("0000a57688","90","50","72","40","nail","normal","86000");
goods[429] =new setGoods("0000a57689","100","50","72","40","nail","normal","101000");
goods[430] =new setGoods("0000a57690","110","50","72","40","nail","normal","102000");
goods[431] =new setGoods("0000a57691","120","50","72","40","nail","normal","106000");
goods[432] =new setGoods("0000a57692","130","50","72","40","nail","normal","108000");
goods[433] =new setGoods("0000a57693","140","50","72","40","nail","normal","108000");
goods[434] =new setGoods("0000a57694","150","50","72","40","nail","normal","108000");
goods[435] =new setGoods("0000a57695","70","60","72","40","nail","normal","87000");
goods[436] =new setGoods("0000a57696","80","60","72","40","nail","normal","89000");
goods[437] =new setGoods("0000a57697","90","60","72","40","nail","normal","90000");
goods[438] =new setGoods("0000a57698","100","60","72","40","nail","normal","104000");
goods[439] =new setGoods("0000a57699","110","60","72","40","nail","normal","106000");
goods[440] =new setGoods("0000a57700","120","60","72","40","nail","normal","112000");
goods[441] =new setGoods("0000a57701","130","60","72","40","nail","normal","112000");
goods[442] =new setGoods("0000a57702","140","60","72","40","nail","normal","113000");
goods[443] =new setGoods("0000a57703","150","60","72","40","nail","normal","113000");
goods[444] =new setGoods("0000a57704","80","70","72","40","nail","normal","92000");
goods[445] =new setGoods("0000a57705","90","70","72","40","nail","normal","93000");
goods[446] =new setGoods("0000a57706","100","70","72","40","nail","normal","111000");
goods[447] =new setGoods("0000a57707","110","70","72","40","nail","normal","111000");
goods[448] =new setGoods("0000a57708","120","70","72","40","nail","normal","116000");
goods[449] =new setGoods("0000a57709","130","70","72","40","nail","normal","116000");
goods[450] =new setGoods("0000a57710","140","70","72","40","nail","normal","116000");
goods[451] =new setGoods("0000a57711","150","70","72","40","nail","normal","116000");
goods[452] =new setGoods("0000a57712","90","80","72","40","nail","normal","93000");
goods[453] =new setGoods("0000a57713","100","80","72","40","nail","normal","112000");
goods[454] =new setGoods("0000a57714","110","80","72","40","nail","normal","113000");
goods[455] =new setGoods("0000a57715","120","80","72","40","nail","normal","116000");
goods[456] =new setGoods("0000a57716","130","80","72","40","nail","normal","116000");
goods[457] =new setGoods("0000a57717","140","80","72","40","nail","normal","116000");
goods[458] =new setGoods("0000a57718","150","80","72","40","nail","normal","118000");
goods[459] =new setGoods("0000a57719","100","90","72","40","nail","normal","113000");
goods[460] =new setGoods("0000a57720","110","90","72","40","nail","normal","115000");
goods[461] =new setGoods("0000a57721","120","90","72","40","nail","normal","116000");
goods[462] =new setGoods("0000a57722","130","90","72","40","nail","normal","116000");
goods[463] =new setGoods("0000a57723","140","90","72","40","nail","normal","118000");
goods[464] =new setGoods("0000a57724","150","90","72","40","nail","normal","120000");
goods[465] =new setGoods("0000a57725","40","40","72","40","nail","normal","51000");
goods[466] =new setGoods("0000a57726","50","50","72","40","nail","normal","75000");
goods[467] =new setGoods("0000a57727","60","60","72","40","nail","normal","81000");
goods[468] =new setGoods("0000a57728","70","70","72","40","nail","normal","91000");
goods[469] =new setGoods("0000a57729","80","80","72","40","nail","normal","92000");
goods[470] =new setGoods("0000a57730","90","90","72","40","nail","normal","94000");
goods[471] =new setGoods("0000a57731","50","40","90","40","nail","normal","54000");
goods[472] =new setGoods("0000a57732","60","40","90","40","nail","normal","55000");
goods[473] =new setGoods("0000a57733","70","40","90","40","nail","normal","59000");
goods[474] =new setGoods("0000a57734","80","40","90","40","nail","normal","59000");
goods[475] =new setGoods("0000a57735","90","40","90","40","nail","normal","60000");
goods[476] =new setGoods("0000a57736","100","40","90","40","nail","normal","68000");
goods[477] =new setGoods("0000a57737","110","40","90","40","nail","normal","70000");
goods[478] =new setGoods("0000a57738","120","40","90","40","nail","normal","73000");
goods[479] =new setGoods("0000a57739","130","40","90","40","nail","normal","73000");
goods[480] =new setGoods("0000a57740","140","40","90","40","nail","normal","75000");
goods[481] =new setGoods("0000a57741","150","40","90","40","nail","normal","75000");
goods[482] =new setGoods("0000a57742","60","50","90","40","nail","normal","79000");
goods[483] =new setGoods("0000a57743","70","50","90","40","nail","normal","84000");
goods[484] =new setGoods("0000a57744","80","50","90","40","nail","normal","86000");
goods[485] =new setGoods("0000a57745","90","50","90","40","nail","normal","87000");
goods[486] =new setGoods("0000a57746","100","50","90","40","nail","normal","101000");
goods[487] =new setGoods("0000a57747","110","50","90","40","nail","normal","103000");
goods[488] =new setGoods("0000a57748","120","50","90","40","nail","normal","108000");
goods[489] =new setGoods("0000a57749","130","50","90","40","nail","normal","109000");
goods[490] =new setGoods("0000a57750","140","50","90","40","nail","normal","109000");
goods[491] =new setGoods("0000a57751","150","50","90","40","nail","normal","109000");
goods[492] =new setGoods("0000a57752","70","60","90","40","nail","normal","88000");
goods[493] =new setGoods("0000a57753","80","60","90","40","nail","normal","89000");
goods[494] =new setGoods("0000a57754","90","60","90","40","nail","normal","90000");
goods[495] =new setGoods("0000a57755","100","60","90","40","nail","normal","105000");
goods[496] =new setGoods("0000a57756","110","60","90","40","nail","normal","106000");
goods[497] =new setGoods("0000a57757","120","60","90","40","nail","normal","113000");
goods[498] =new setGoods("0000a57758","130","60","90","40","nail","normal","113000");
goods[499] =new setGoods("0000a57759","140","60","90","40","nail","normal","113000");
goods[500] =new setGoods("0000a57760","150","60","90","40","nail","normal","113000");
goods[501] =new setGoods("0000a57761","80","70","90","40","nail","normal","92000");
goods[502] =new setGoods("0000a57762","90","70","90","40","nail","normal","94000");
goods[503] =new setGoods("0000a57763","100","70","90","40","nail","normal","112000");
goods[504] =new setGoods("0000a57764","110","70","90","40","nail","normal","112000");
goods[505] =new setGoods("0000a57765","120","70","90","40","nail","normal","116000");
goods[506] =new setGoods("0000a57766","130","70","90","40","nail","normal","116000");
goods[507] =new setGoods("0000a57767","140","70","90","40","nail","normal","117000");
goods[508] =new setGoods("0000a57768","150","70","90","40","nail","normal","117000");
goods[509] =new setGoods("0000a57769","90","80","90","40","nail","normal","94000");
goods[510] =new setGoods("0000a57770","100","80","90","40","nail","normal","113000");
goods[511] =new setGoods("0000a57771","110","80","90","40","nail","normal","115000");
goods[512] =new setGoods("0000a57772","120","80","90","40","nail","normal","116000");
goods[513] =new setGoods("0000a57773","130","80","90","40","nail","normal","117000");
goods[514] =new setGoods("0000a57774","140","80","90","40","nail","normal","117000");
goods[515] =new setGoods("0000a57775","150","80","90","40","nail","normal","120000");
goods[516] =new setGoods("0000a57776","100","90","90","40","nail","normal","115000");
goods[517] =new setGoods("0000a57777","110","90","90","40","nail","normal","116000");
goods[518] =new setGoods("0000a57778","120","90","90","40","nail","normal","117000");
goods[519] =new setGoods("0000a57779","130","90","90","40","nail","normal","117000");
goods[520] =new setGoods("0000a57780","140","90","90","40","nail","normal","120000");
goods[521] =new setGoods("0000a57781","150","90","90","40","nail","normal","120000");
goods[522] =new setGoods("0000a57782","40","40","90","40","nail","normal","52000");
goods[523] =new setGoods("0000a57783","50","50","90","40","nail","normal","78000");
goods[524] =new setGoods("0000a57784","60","60","90","40","nail","normal","82000");
goods[525] =new setGoods("0000a57785","70","70","90","40","nail","normal","91000");
goods[526] =new setGoods("0000a57786","80","80","90","40","nail","normal","92000");
goods[527] =new setGoods("0000a57787","90","90","90","40","nail","normal","95000");
goods[528] =new setGoods("0000a57788","40","30","42","40","black","normal","30000");
goods[529] =new setGoods("0000a57789","50","30","42","40","black","normal","32000");
goods[530] =new setGoods("0000a57790","60","30","42","40","black","normal","32000");
goods[531] =new setGoods("0000a57791","70","30","42","40","black","normal","35000");
goods[532] =new setGoods("0000a57792","80","30","42","40","black","normal","37000");
goods[533] =new setGoods("0000a57793","90","30","42","40","black","normal","38000");
goods[534] =new setGoods("0000a57794","100","30","42","40","black","normal","42000");
goods[535] =new setGoods("0000a57795","110","30","42","40","black","normal","46000");
goods[536] =new setGoods("0000a57796","120","30","42","40","black","normal","49000");
goods[537] =new setGoods("0000a57797","130","30","42","40","black","normal","49000");
goods[538] =new setGoods("0000a57798","140","30","42","40","black","normal","49000");
goods[539] =new setGoods("0000a57799","150","30","42","40","black","normal","51000");
goods[540] =new setGoods("0000a57800","50","40","42","40","black","normal","40000");
goods[541] =new setGoods("0000a57801","60","40","42","40","black","normal","41000");
goods[542] =new setGoods("0000a57802","70","40","42","40","black","normal","43000");
goods[543] =new setGoods("0000a57803","80","40","42","40","black","normal","44000");
goods[544] =new setGoods("0000a57804","90","40","42","40","black","normal","46000");
goods[545] =new setGoods("0000a57805","100","40","42","40","black","normal","55000");
goods[546] =new setGoods("0000a57806","110","40","42","40","black","normal","57000");
goods[547] =new setGoods("0000a57807","120","40","42","40","black","normal","59000");
goods[548] =new setGoods("0000a57808","130","40","42","40","black","normal","60000");
goods[549] =new setGoods("0000a57809","140","40","42","40","black","normal","61000");
goods[550] =new setGoods("0000a57810","150","40","42","40","black","normal","61000");
goods[551] =new setGoods("0000a57811","60","50","42","40","black","normal","57000");
goods[552] =new setGoods("0000a57812","70","50","42","40","black","normal","62000");
goods[553] =new setGoods("0000a57813","80","50","42","40","black","normal","64000");
goods[554] =new setGoods("0000a57814","90","50","42","40","black","normal","66000");
goods[555] =new setGoods("0000a57815","100","50","42","40","black","normal","80000");
goods[556] =new setGoods("0000a57816","110","50","42","40","black","normal","82000");
goods[557] =new setGoods("0000a57817","120","50","42","40","black","normal","87000");
goods[558] =new setGoods("0000a57818","130","50","42","40","black","normal","88000");
goods[559] =new setGoods("0000a57819","140","50","42","40","black","normal","88000");
goods[560] =new setGoods("0000a57820","150","50","42","40","black","normal","88000");
goods[561] =new setGoods("0000a57821","70","60","42","40","black","normal","66000");
goods[562] =new setGoods("0000a57822","80","60","42","40","black","normal","68000");
goods[563] =new setGoods("0000a57823","90","60","42","40","black","normal","69000");
goods[564] =new setGoods("0000a57824","100","60","42","40","black","normal","84000");
goods[565] =new setGoods("0000a57825","110","60","42","40","black","normal","87000");
goods[566] =new setGoods("0000a57826","120","60","42","40","black","normal","92000");
goods[567] =new setGoods("0000a57827","130","60","42","40","black","normal","92000");
goods[568] =new setGoods("0000a57828","140","60","42","40","black","normal","92000");
goods[569] =new setGoods("0000a57829","150","60","42","40","black","normal","92000");
goods[570] =new setGoods("0000a57830","80","70","42","40","black","normal","70000");
goods[571] =new setGoods("0000a57831","90","70","42","40","black","normal","72000");
goods[572] =new setGoods("0000a57832","100","70","42","40","black","normal","90000");
goods[573] =new setGoods("0000a57833","110","70","42","40","black","normal","90000");
goods[574] =new setGoods("0000a57834","120","70","42","40","black","normal","94000");
goods[575] =new setGoods("0000a57835","130","70","42","40","black","normal","94000");
goods[576] =new setGoods("0000a57836","140","70","42","40","black","normal","95000");
goods[577] =new setGoods("0000a57837","150","70","42","40","black","normal","95000");
goods[578] =new setGoods("0000a57838","90","80","42","40","black","normal","72000");
goods[579] =new setGoods("0000a57839","100","80","42","40","black","normal","91000");
goods[580] =new setGoods("0000a57840","110","80","42","40","black","normal","91000");
goods[581] =new setGoods("0000a57841","120","80","42","40","black","normal","94000");
goods[582] =new setGoods("0000a57842","130","80","42","40","black","normal","95000");
goods[583] =new setGoods("0000a57843","140","80","42","40","black","normal","95000");
goods[584] =new setGoods("0000a57844","150","80","42","40","black","normal","98000");
goods[585] =new setGoods("0000a57845","100","90","42","40","black","normal","91000");
goods[586] =new setGoods("0000a57846","110","90","42","40","black","normal","91000");
goods[587] =new setGoods("0000a57847","120","90","42","40","black","normal","95000");
goods[588] =new setGoods("0000a57848","130","90","42","40","black","normal","95000");
goods[589] =new setGoods("0000a57849","140","90","42","40","black","normal","98000");
goods[590] =new setGoods("0000a57850","150","90","42","40","black","normal","98000");
goods[591] =new setGoods("0000a57851","40","40","42","40","black","normal","38000");
goods[592] =new setGoods("0000a57852","50","50","42","40","black","normal","55000");
goods[593] =new setGoods("0000a57853","60","60","42","40","black","normal","60000");
goods[594] =new setGoods("0000a57854","70","70","42","40","black","normal","69000");
goods[595] =new setGoods("0000a57855","80","80","42","40","black","normal","70000");
goods[596] =new setGoods("0000a57856","90","90","42","40","black","normal","73000");
goods[597] =new setGoods("0000a57857","40","30","60","40","black","normal","35000");
goods[598] =new setGoods("0000a57858","50","30","60","40","black","normal","38000");
goods[599] =new setGoods("0000a57859","60","30","60","40","black","normal","38000");
goods[600] =new setGoods("0000a57860","70","30","60","40","black","normal","40000");
goods[601] =new setGoods("0000a57861","80","30","60","40","black","normal","41000");
goods[602] =new setGoods("0000a57862","90","30","60","40","black","normal","42000");
goods[603] =new setGoods("0000a57863","100","30","60","40","black","normal","48000");
goods[604] =new setGoods("0000a57864","110","30","60","40","black","normal","50000");
goods[605] =new setGoods("0000a57865","120","30","60","40","black","normal","54000");
goods[606] =new setGoods("0000a57866","130","30","60","40","black","normal","54000");
goods[607] =new setGoods("0000a57867","140","30","60","40","black","normal","54000");
goods[608] =new setGoods("0000a57868","150","30","60","40","black","normal","55000");
goods[609] =new setGoods("0000a57869","50","40","60","40","black","normal","44000");
goods[610] =new setGoods("0000a57870","60","40","60","40","black","normal","46000");
goods[611] =new setGoods("0000a57871","70","40","60","40","black","normal","49000");
goods[612] =new setGoods("0000a57872","80","40","60","40","black","normal","49000");
goods[613] =new setGoods("0000a57873","90","40","60","40","black","normal","51000");
goods[614] =new setGoods("0000a57874","100","40","60","40","black","normal","59000");
goods[615] =new setGoods("0000a57875","110","40","60","40","black","normal","61000");
goods[616] =new setGoods("0000a57876","120","40","60","40","black","normal","65000");
goods[617] =new setGoods("0000a57877","130","40","60","40","black","normal","65000");
goods[618] =new setGoods("0000a57878","140","40","60","40","black","normal","66000");
goods[619] =new setGoods("0000a57879","150","40","60","40","black","normal","66000");
goods[620] =new setGoods("0000a57880","60","50","60","40","black","normal","63000");
goods[621] =new setGoods("0000a57881","70","50","60","40","black","normal","70000");
goods[622] =new setGoods("0000a57882","80","50","60","40","black","normal","71000");
goods[623] =new setGoods("0000a57883","90","50","60","40","black","normal","73000");
goods[624] =new setGoods("0000a57884","100","50","60","40","black","normal","88000");
goods[625] =new setGoods("0000a57885","110","50","60","40","black","normal","90000");
goods[626] =new setGoods("0000a57886","120","50","60","40","black","normal","93000");
goods[627] =new setGoods("0000a57887","130","50","60","40","black","normal","94000");
goods[628] =new setGoods("0000a57888","140","50","60","40","black","normal","95000");
goods[629] =new setGoods("0000a57889","150","50","60","40","black","normal","95000");
goods[630] =new setGoods("0000a57890","70","60","60","40","black","normal","74000");
goods[631] =new setGoods("0000a57891","80","60","60","40","black","normal","76000");
goods[632] =new setGoods("0000a57892","90","60","60","40","black","normal","77000");
goods[633] =new setGoods("0000a57893","100","60","60","40","black","normal","91000");
goods[634] =new setGoods("0000a57894","110","60","60","40","black","normal","93000");
goods[635] =new setGoods("0000a57895","120","60","60","40","black","normal","100000");
goods[636] =new setGoods("0000a57896","130","60","60","40","black","normal","100000");
goods[637] =new setGoods("0000a57897","140","60","60","40","black","normal","100000");
goods[638] =new setGoods("0000a57898","150","60","60","40","black","normal","100000");
goods[639] =new setGoods("0000a57899","80","70","60","40","black","normal","78000");
goods[640] =new setGoods("0000a57900","90","70","60","40","black","normal","80000");
goods[641] =new setGoods("0000a57901","100","70","60","40","black","normal","98000");
goods[642] =new setGoods("0000a57902","110","70","60","40","black","normal","98000");
goods[643] =new setGoods("0000a57903","120","70","60","40","black","normal","102000");
goods[644] =new setGoods("0000a57904","130","70","60","40","black","normal","103000");
goods[645] =new setGoods("0000a57905","140","70","60","40","black","normal","103000");
goods[646] =new setGoods("0000a57906","150","70","60","40","black","normal","103000");
goods[647] =new setGoods("0000a57907","90","80","60","40","black","normal","80000");
goods[648] =new setGoods("0000a57908","100","80","60","40","black","normal","99000");
goods[649] =new setGoods("0000a57909","110","80","60","40","black","normal","100000");
goods[650] =new setGoods("0000a57910","120","80","60","40","black","normal","103000");
goods[651] =new setGoods("0000a57911","130","80","60","40","black","normal","103000");
goods[652] =new setGoods("0000a57912","140","80","60","40","black","normal","103000");
goods[653] =new setGoods("0000a57913","150","80","60","40","black","normal","105000");
goods[654] =new setGoods("0000a57914","100","90","60","40","black","normal","100000");
goods[655] =new setGoods("0000a57915","110","90","60","40","black","normal","102000");
goods[656] =new setGoods("0000a57916","120","90","60","40","black","normal","103000");
goods[657] =new setGoods("0000a57917","130","90","60","40","black","normal","103000");
goods[658] =new setGoods("0000a57918","140","90","60","40","black","normal","105000");
goods[659] =new setGoods("0000a57919","150","90","60","40","black","normal","105000");
goods[660] =new setGoods("0000a57920","40","40","60","40","black","normal","42000");
goods[661] =new setGoods("0000a57921","50","50","60","40","black","normal","62000");
goods[662] =new setGoods("0000a57922","60","60","60","40","black","normal","66000");
goods[663] =new setGoods("0000a57923","70","70","60","40","black","normal","77000");
goods[664] =new setGoods("0000a57924","80","80","60","40","black","normal","78000");
goods[665] =new setGoods("0000a57925","90","90","60","40","black","normal","81000");
goods[666] =new setGoods("0000a57926","40","30","72","40","black","normal","42000");
goods[667] =new setGoods("0000a57927","50","30","72","40","black","normal","43000");
goods[668] =new setGoods("0000a57928","60","30","72","40","black","normal","44000");
goods[669] =new setGoods("0000a57929","70","30","72","40","black","normal","47000");
goods[670] =new setGoods("0000a57930","80","30","72","40","black","normal","48000");
goods[671] =new setGoods("0000a57931","90","30","72","40","black","normal","49000");
goods[672] =new setGoods("0000a57932","100","30","72","40","black","normal","54000");
goods[673] =new setGoods("0000a57933","110","30","72","40","black","normal","57000");
goods[674] =new setGoods("0000a57934","120","30","72","40","black","normal","60000");
goods[675] =new setGoods("0000a57935","130","30","72","40","black","normal","60000");
goods[676] =new setGoods("0000a57936","140","30","72","40","black","normal","60000");
goods[677] =new setGoods("0000a57937","150","30","72","40","black","normal","61000");
goods[678] =new setGoods("0000a57938","50","40","72","40","black","normal","53000");
goods[679] =new setGoods("0000a57939","60","40","72","40","black","normal","53000");
goods[680] =new setGoods("0000a57940","70","40","72","40","black","normal","57000");
goods[681] =new setGoods("0000a57941","80","40","72","40","black","normal","58000");
goods[682] =new setGoods("0000a57942","90","40","72","40","black","normal","60000");
goods[683] =new setGoods("0000a57943","100","40","72","40","black","normal","68000");
goods[684] =new setGoods("0000a57944","110","40","72","40","black","normal","69000");
goods[685] =new setGoods("0000a57945","120","40","72","40","black","normal","72000");
goods[686] =new setGoods("0000a57946","130","40","72","40","black","normal","72000");
goods[687] =new setGoods("0000a57947","140","40","72","40","black","normal","75000");
goods[688] =new setGoods("0000a57948","150","40","72","40","black","normal","75000");
goods[689] =new setGoods("0000a57949","60","50","72","40","black","normal","76000");
goods[690] =new setGoods("0000a57950","70","50","72","40","black","normal","82000");
goods[691] =new setGoods("0000a57951","80","50","72","40","black","normal","84000");
goods[692] =new setGoods("0000a57952","90","50","72","40","black","normal","86000");
goods[693] =new setGoods("0000a57953","100","50","72","40","black","normal","101000");
goods[694] =new setGoods("0000a57954","110","50","72","40","black","normal","102000");
goods[695] =new setGoods("0000a57955","120","50","72","40","black","normal","106000");
goods[696] =new setGoods("0000a57956","130","50","72","40","black","normal","108000");
goods[697] =new setGoods("0000a57957","140","50","72","40","black","normal","108000");
goods[698] =new setGoods("0000a57958","150","50","72","40","black","normal","108000");
goods[699] =new setGoods("0000a57959","70","60","72","40","black","normal","87000");
goods[700] =new setGoods("0000a57960","80","60","72","40","black","normal","89000");
goods[701] =new setGoods("0000a57961","90","60","72","40","black","normal","90000");
goods[702] =new setGoods("0000a57962","100","60","72","40","black","normal","104000");
goods[703] =new setGoods("0000a57963","110","60","72","40","black","normal","106000");
goods[704] =new setGoods("0000a57964","120","60","72","40","black","normal","112000");
goods[705] =new setGoods("0000a57965","130","60","72","40","black","normal","112000");
goods[706] =new setGoods("0000a57966","140","60","72","40","black","normal","113000");
goods[707] =new setGoods("0000a57967","150","60","72","40","black","normal","113000");
goods[708] =new setGoods("0000a57968","80","70","72","40","black","normal","92000");
goods[709] =new setGoods("0000a57969","90","70","72","40","black","normal","93000");
goods[710] =new setGoods("0000a57970","100","70","72","40","black","normal","111000");
goods[711] =new setGoods("0000a57971","110","70","72","40","black","normal","111000");
goods[712] =new setGoods("0000a57972","120","70","72","40","black","normal","116000");
goods[713] =new setGoods("0000a57973","130","70","72","40","black","normal","116000");
goods[714] =new setGoods("0000a57974","140","70","72","40","black","normal","116000");
goods[715] =new setGoods("0000a57975","150","70","72","40","black","normal","116000");
goods[716] =new setGoods("0000a57976","90","80","72","40","black","normal","93000");
goods[717] =new setGoods("0000a57977","100","80","72","40","black","normal","112000");
goods[718] =new setGoods("0000a57978","110","80","72","40","black","normal","113000");
goods[719] =new setGoods("0000a57979","120","80","72","40","black","normal","116000");
goods[720] =new setGoods("0000a57980","130","80","72","40","black","normal","116000");
goods[721] =new setGoods("0000a57981","140","80","72","40","black","normal","116000");
goods[722] =new setGoods("0000a57982","150","80","72","40","black","normal","118000");
goods[723] =new setGoods("0000a57983","100","90","72","40","black","normal","113000");
goods[724] =new setGoods("0000a57984","110","90","72","40","black","normal","115000");
goods[725] =new setGoods("0000a57985","120","90","72","40","black","normal","116000");
goods[726] =new setGoods("0000a57986","130","90","72","40","black","normal","116000");
goods[727] =new setGoods("0000a57987","140","90","72","40","black","normal","118000");
goods[728] =new setGoods("0000a57988","150","90","72","40","black","normal","120000");
goods[729] =new setGoods("0000a57989","40","40","72","40","black","normal","51000");
goods[730] =new setGoods("0000a57990","50","50","72","40","black","normal","75000");
goods[731] =new setGoods("0000a57991","60","60","72","40","black","normal","81000");
goods[732] =new setGoods("0000a57992","70","70","72","40","black","normal","91000");
goods[733] =new setGoods("0000a57993","80","80","72","40","black","normal","92000");
goods[734] =new setGoods("0000a57994","90","90","72","40","black","normal","94000");
goods[735] =new setGoods("0000a57995","50","40","90","40","black","normal","54000");
goods[736] =new setGoods("0000a57996","60","40","90","40","black","normal","55000");
goods[737] =new setGoods("0000a57997","70","40","90","40","black","normal","59000");
goods[738] =new setGoods("0000a57998","80","40","90","40","black","normal","59000");
goods[739] =new setGoods("0000a57999","90","40","90","40","black","normal","60000");
goods[740] =new setGoods("0000a58000","100","40","90","40","black","normal","68000");
goods[741] =new setGoods("0000a58001","110","40","90","40","black","normal","70000");
goods[742] =new setGoods("0000a58002","120","40","90","40","black","normal","73000");
goods[743] =new setGoods("0000a58003","130","40","90","40","black","normal","73000");
goods[744] =new setGoods("0000a58004","140","40","90","40","black","normal","75000");
goods[745] =new setGoods("0000a58005","150","40","90","40","black","normal","75000");
goods[746] =new setGoods("0000a58006","60","50","90","40","black","normal","79000");
goods[747] =new setGoods("0000a58007","70","50","90","40","black","normal","84000");
goods[748] =new setGoods("0000a58008","80","50","90","40","black","normal","86000");
goods[749] =new setGoods("0000a58009","90","50","90","40","black","normal","87000");
goods[750] =new setGoods("0000a58010","100","50","90","40","black","normal","101000");
goods[751] =new setGoods("0000a58011","110","50","90","40","black","normal","103000");
goods[752] =new setGoods("0000a58012","120","50","90","40","black","normal","108000");
goods[753] =new setGoods("0000a58013","130","50","90","40","black","normal","109000");
goods[754] =new setGoods("0000a58014","140","50","90","40","black","normal","109000");
goods[755] =new setGoods("0000a58015","150","50","90","40","black","normal","109000");
goods[756] =new setGoods("0000a58016","70","60","90","40","black","normal","88000");
goods[757] =new setGoods("0000a58017","80","60","90","40","black","normal","89000");
goods[758] =new setGoods("0000a58018","90","60","90","40","black","normal","90000");
goods[759] =new setGoods("0000a58019","100","60","90","40","black","normal","105000");
goods[760] =new setGoods("0000a58020","110","60","90","40","black","normal","106000");
goods[761] =new setGoods("0000a58021","120","60","90","40","black","normal","113000");
goods[762] =new setGoods("0000a58022","130","60","90","40","black","normal","113000");
goods[763] =new setGoods("0000a58023","140","60","90","40","black","normal","113000");
goods[764] =new setGoods("0000a58024","150","60","90","40","black","normal","113000");
goods[765] =new setGoods("0000a58025","80","70","90","40","black","normal","92000");
goods[766] =new setGoods("0000a58026","90","70","90","40","black","normal","94000");
goods[767] =new setGoods("0000a58027","100","70","90","40","black","normal","112000");
goods[768] =new setGoods("0000a58028","110","70","90","40","black","normal","112000");
goods[769] =new setGoods("0000a58029","120","70","90","40","black","normal","116000");
goods[770] =new setGoods("0000a58030","130","70","90","40","black","normal","116000");
goods[771] =new setGoods("0000a58031","140","70","90","40","black","normal","117000");
goods[772] =new setGoods("0000a58032","150","70","90","40","black","normal","117000");
goods[773] =new setGoods("0000a58033","90","80","90","40","black","normal","94000");
goods[774] =new setGoods("0000a58034","100","80","90","40","black","normal","113000");
goods[775] =new setGoods("0000a58035","110","80","90","40","black","normal","115000");
goods[776] =new setGoods("0000a58036","120","80","90","40","black","normal","116000");
goods[777] =new setGoods("0000a58037","130","80","90","40","black","normal","117000");
goods[778] =new setGoods("0000a58038","140","80","90","40","black","normal","117000");
goods[779] =new setGoods("0000a58039","150","80","90","40","black","normal","120000");
goods[780] =new setGoods("0000a58040","100","90","90","40","black","normal","115000");
goods[781] =new setGoods("0000a58041","110","90","90","40","black","normal","116000");
goods[782] =new setGoods("0000a58042","120","90","90","40","black","normal","117000");
goods[783] =new setGoods("0000a58043","130","90","90","40","black","normal","117000");
goods[784] =new setGoods("0000a58044","140","90","90","40","black","normal","120000");
goods[785] =new setGoods("0000a58045","150","90","90","40","black","normal","120000");
goods[786] =new setGoods("0000a58046","40","40","90","40","black","normal","52000");
goods[787] =new setGoods("0000a58047","50","50","90","40","black","normal","78000");
goods[788] =new setGoods("0000a58048","60","60","90","40","black","normal","82000");
goods[789] =new setGoods("0000a58049","70","70","90","40","black","normal","91000");
goods[790] =new setGoods("0000a58050","80","80","90","40","black","normal","92000");
goods[791] =new setGoods("0000a58051","90","90","90","40","black","normal","95000");
goods[792] =new setGoods("0000a58052","40","30","42","40","bp","normal","35000");
goods[793] =new setGoods("0000a58053","50","30","42","40","bp","normal","38000");
goods[794] =new setGoods("0000a58054","60","30","42","40","bp","normal","39000");
goods[795] =new setGoods("0000a58055","70","30","42","40","bp","normal","41000");
goods[796] =new setGoods("0000a58056","80","30","42","40","bp","normal","42000");
goods[797] =new setGoods("0000a58057","90","30","42","40","bp","normal","43000");
goods[798] =new setGoods("0000a58058","100","30","42","40","bp","normal","50000");
goods[799] =new setGoods("0000a58059","110","30","42","40","bp","normal","54000");
goods[800] =new setGoods("0000a58060","120","30","42","40","bp","normal","57000");
goods[801] =new setGoods("0000a58061","130","30","42","40","bp","normal","57000");
goods[802] =new setGoods("0000a58062","140","30","42","40","bp","normal","58000");
goods[803] =new setGoods("0000a58063","150","30","42","40","bp","normal","59000");
goods[804] =new setGoods("0000a58064","50","40","42","40","bp","normal","46000");
goods[805] =new setGoods("0000a58065","60","40","42","40","bp","normal","47000");
goods[806] =new setGoods("0000a58066","70","40","42","40","bp","normal","51000");
goods[807] =new setGoods("0000a58067","80","40","42","40","bp","normal","52000");
goods[808] =new setGoods("0000a58068","90","40","42","40","bp","normal","53000");
goods[809] =new setGoods("0000a58069","100","40","42","40","bp","normal","65000");
goods[810] =new setGoods("0000a58070","110","40","42","40","bp","normal","67000");
goods[811] =new setGoods("0000a58071","120","40","42","40","bp","normal","69000");
goods[812] =new setGoods("0000a58072","130","40","42","40","bp","normal","70000");
goods[813] =new setGoods("0000a58073","140","40","42","40","bp","normal","71000");
goods[814] =new setGoods("0000a58074","150","40","42","40","bp","normal","71000");
goods[815] =new setGoods("0000a58075","60","50","42","40","bp","normal","66000");
goods[816] =new setGoods("0000a58076","70","50","42","40","bp","normal","73000");
goods[817] =new setGoods("0000a58077","80","50","42","40","bp","normal","75000");
goods[818] =new setGoods("0000a58078","90","50","42","40","bp","normal","78000");
goods[819] =new setGoods("0000a58079","100","50","42","40","bp","normal","97000");
goods[820] =new setGoods("0000a58080","110","50","42","40","bp","normal","99000");
goods[821] =new setGoods("0000a58081","120","50","42","40","bp","normal","103000");
goods[822] =new setGoods("0000a58082","130","50","42","40","bp","normal","104000");
goods[823] =new setGoods("0000a58083","140","50","42","40","bp","normal","104000");
goods[824] =new setGoods("0000a58084","150","50","42","40","bp","normal","105000");
goods[825] =new setGoods("0000a58085","70","60","42","40","bp","normal","78000");
goods[826] =new setGoods("0000a58086","80","60","42","40","bp","normal","80000");
goods[827] =new setGoods("0000a58087","90","60","42","40","bp","normal","81000");
goods[828] =new setGoods("0000a58088","100","60","42","40","bp","normal","101000");
goods[829] =new setGoods("0000a58089","110","60","42","40","bp","normal","103000");
goods[830] =new setGoods("0000a58090","120","60","42","40","bp","normal","109000");
goods[831] =new setGoods("0000a58091","130","60","42","40","bp","normal","109000");
goods[832] =new setGoods("0000a58092","140","60","42","40","bp","normal","110000");
goods[833] =new setGoods("0000a58093","150","60","42","40","bp","normal","110000");
goods[834] =new setGoods("0000a58094","80","70","42","40","bp","normal","82000");
goods[835] =new setGoods("0000a58095","90","70","42","40","bp","normal","84000");
goods[836] =new setGoods("0000a58096","100","70","42","40","bp","normal","106000");
goods[837] =new setGoods("0000a58097","110","70","42","40","bp","normal","106000");
goods[838] =new setGoods("0000a58098","120","70","42","40","bp","normal","112000");
goods[839] =new setGoods("0000a58099","130","70","42","40","bp","normal","112000");
goods[840] =new setGoods("0000a58100","140","70","42","40","bp","normal","112000");
goods[841] =new setGoods("0000a58101","150","70","42","40","bp","normal","112000");
goods[842] =new setGoods("0000a58102","90","80","42","40","bp","normal","84000");
goods[843] =new setGoods("0000a58103","100","80","42","40","bp","normal","108000");
goods[844] =new setGoods("0000a58104","110","80","42","40","bp","normal","110000");
goods[845] =new setGoods("0000a58105","120","80","42","40","bp","normal","112000");
goods[846] =new setGoods("0000a58106","130","80","42","40","bp","normal","112000");
goods[847] =new setGoods("0000a58107","140","80","42","40","bp","normal","113000");
goods[848] =new setGoods("0000a58108","150","80","42","40","bp","normal","115000");
goods[849] =new setGoods("0000a58109","100","90","42","40","bp","normal","110000");
goods[850] =new setGoods("0000a58110","110","90","42","40","bp","normal","111000");
goods[851] =new setGoods("0000a58111","120","90","42","40","bp","normal","112000");
goods[852] =new setGoods("0000a58112","130","90","42","40","bp","normal","112000");
goods[853] =new setGoods("0000a58113","140","90","42","40","bp","normal","115000");
goods[854] =new setGoods("0000a58114","150","90","42","40","bp","normal","115000");
goods[855] =new setGoods("0000a58115","40","40","42","40","bp","normal","43000");
goods[856] =new setGoods("0000a58116","50","50","42","40","bp","normal","65000");
goods[857] =new setGoods("0000a58117","60","60","42","40","bp","normal","70000");
goods[858] =new setGoods("0000a58118","70","70","42","40","bp","normal","81000");
goods[859] =new setGoods("0000a58119","80","80","42","40","bp","normal","82000");
goods[860] =new setGoods("0000a58120","90","90","42","40","bp","normal","86000");
goods[861] =new setGoods("0000a58121","40","30","60","40","bp","normal","41000");
goods[862] =new setGoods("0000a58122","50","30","60","40","bp","normal","43000");
goods[863] =new setGoods("0000a58123","60","30","60","40","bp","normal","43000");
goods[864] =new setGoods("0000a58124","70","30","60","40","bp","normal","47000");
goods[865] =new setGoods("0000a58125","80","30","60","40","bp","normal","48000");
goods[866] =new setGoods("0000a58126","90","30","60","40","bp","normal","49000");
goods[867] =new setGoods("0000a58127","100","30","60","40","bp","normal","56000");
goods[868] =new setGoods("0000a58128","110","30","60","40","bp","normal","59000");
goods[869] =new setGoods("0000a58129","120","30","60","40","bp","normal","62000");
goods[870] =new setGoods("0000a58130","130","30","60","40","bp","normal","62000");
goods[871] =new setGoods("0000a58131","140","30","60","40","bp","normal","62000");
goods[872] =new setGoods("0000a58132","150","30","60","40","bp","normal","64000");
goods[873] =new setGoods("0000a58133","50","40","60","40","bp","normal","52000");
goods[874] =new setGoods("0000a58134","60","40","60","40","bp","normal","53000");
goods[875] =new setGoods("0000a58135","70","40","60","40","bp","normal","57000");
goods[876] =new setGoods("0000a58136","80","40","60","40","bp","normal","58000");
goods[877] =new setGoods("0000a58137","90","40","60","40","bp","normal","60000");
goods[878] =new setGoods("0000a58138","100","40","60","40","bp","normal","70000");
goods[879] =new setGoods("0000a58139","110","40","60","40","bp","normal","72000");
goods[880] =new setGoods("0000a58140","120","40","60","40","bp","normal","76000");
goods[881] =new setGoods("0000a58141","130","40","60","40","bp","normal","76000");
goods[882] =new setGoods("0000a58142","140","40","60","40","bp","normal","77000");
goods[883] =new setGoods("0000a58143","150","40","60","40","bp","normal","78000");
goods[884] =new setGoods("0000a58144","60","50","60","40","bp","normal","75000");
goods[885] =new setGoods("0000a58145","70","50","60","40","bp","normal","83000");
goods[886] =new setGoods("0000a58146","80","50","60","40","bp","normal","85000");
goods[887] =new setGoods("0000a58147","90","50","60","40","bp","normal","87000");
goods[888] =new setGoods("0000a58148","100","50","60","40","bp","normal","105000");
goods[889] =new setGoods("0000a58149","110","50","60","40","bp","normal","108000");
goods[890] =new setGoods("0000a58150","120","50","60","40","bp","normal","112000");
goods[891] =new setGoods("0000a58151","130","50","60","40","bp","normal","113000");
goods[892] =new setGoods("0000a58152","140","50","60","40","bp","normal","114000");
goods[893] =new setGoods("0000a58153","150","50","60","40","bp","normal","114000");
goods[894] =new setGoods("0000a58154","70","60","60","40","bp","normal","87000");
goods[895] =new setGoods("0000a58155","80","60","60","40","bp","normal","89000");
goods[896] =new setGoods("0000a58156","90","60","60","40","bp","normal","91000");
goods[897] =new setGoods("0000a58157","100","60","60","40","bp","normal","110000");
goods[898] =new setGoods("0000a58158","110","60","60","40","bp","normal","112000");
goods[899] =new setGoods("0000a58159","120","60","60","40","bp","normal","119000");
goods[900] =new setGoods("0000a58160","130","60","60","40","bp","normal","119000");
goods[901] =new setGoods("0000a58161","140","60","60","40","bp","normal","119000");
goods[902] =new setGoods("0000a58162","150","60","60","40","bp","normal","119000");
goods[903] =new setGoods("0000a58163","80","70","60","40","bp","normal","92000");
goods[904] =new setGoods("0000a58164","90","70","60","40","bp","normal","94000");
goods[905] =new setGoods("0000a58165","100","70","60","40","bp","normal","116000");
goods[906] =new setGoods("0000a58166","110","70","60","40","bp","normal","116000");
goods[907] =new setGoods("0000a58167","120","70","60","40","bp","normal","121000");
goods[908] =new setGoods("0000a58168","130","70","60","40","bp","normal","122000");
goods[909] =new setGoods("0000a58169","140","70","60","40","bp","normal","122000");
goods[910] =new setGoods("0000a58170","150","70","60","40","bp","normal","122000");
goods[911] =new setGoods("0000a58171","90","80","60","40","bp","normal","94000");
goods[912] =new setGoods("0000a58172","100","80","60","40","bp","normal","117000");
goods[913] =new setGoods("0000a58173","110","80","60","40","bp","normal","120000");
goods[914] =new setGoods("0000a58174","120","80","60","40","bp","normal","122000");
goods[915] =new setGoods("0000a58175","130","80","60","40","bp","normal","122000");
goods[916] =new setGoods("0000a58176","140","80","60","40","bp","normal","122000");
goods[917] =new setGoods("0000a58177","150","80","60","40","bp","normal","125000");
goods[918] =new setGoods("0000a58178","100","90","60","40","bp","normal","120000");
goods[919] =new setGoods("0000a58179","110","90","60","40","bp","normal","121000");
goods[920] =new setGoods("0000a58180","120","90","60","40","bp","normal","122000");
goods[921] =new setGoods("0000a58181","130","90","60","40","bp","normal","122000");
goods[922] =new setGoods("0000a58182","140","90","60","40","bp","normal","125000");
goods[923] =new setGoods("0000a58183","150","90","60","40","bp","normal","125000");
goods[924] =new setGoods("0000a58184","40","40","60","40","bp","normal","49000");
goods[925] =new setGoods("0000a58185","50","50","60","40","bp","normal","74000");
goods[926] =new setGoods("0000a58186","60","60","60","40","bp","normal","79000");
goods[927] =new setGoods("0000a58187","70","70","60","40","bp","normal","91000");
goods[928] =new setGoods("0000a58188","80","80","60","40","bp","normal","92000");
goods[929] =new setGoods("0000a58189","90","90","60","40","bp","normal","95000");
goods[930] =new setGoods("0000a58190","40","30","72","40","bp","normal","49000");
goods[931] =new setGoods("0000a58191","50","30","72","40","bp","normal","51000");
goods[932] =new setGoods("0000a58192","60","30","72","40","bp","normal","51000");
goods[933] =new setGoods("0000a58193","70","30","72","40","bp","normal","54000");
goods[934] =new setGoods("0000a58194","80","30","72","40","bp","normal","55000");
goods[935] =new setGoods("0000a58195","90","30","72","40","bp","normal","57000");
goods[936] =new setGoods("0000a58196","100","30","72","40","bp","normal","64000");
goods[937] =new setGoods("0000a58197","110","30","72","40","bp","normal","67000");
goods[938] =new setGoods("0000a58198","120","30","72","40","bp","normal","70000");
goods[939] =new setGoods("0000a58199","130","30","72","40","bp","normal","70000");
goods[940] =new setGoods("0000a58200","140","30","72","40","bp","normal","70000");
goods[941] =new setGoods("0000a58201","150","30","72","40","bp","normal","72000");
goods[942] =new setGoods("0000a58202","50","40","72","40","bp","normal","62000");
goods[943] =new setGoods("0000a58203","60","40","72","40","bp","normal","63000");
goods[944] =new setGoods("0000a58204","70","40","72","40","bp","normal","66000");
goods[945] =new setGoods("0000a58205","80","40","72","40","bp","normal","68000");
goods[946] =new setGoods("0000a58206","90","40","72","40","bp","normal","70000");
goods[947] =new setGoods("0000a58207","100","40","72","40","bp","normal","80000");
goods[948] =new setGoods("0000a58208","110","40","72","40","bp","normal","82000");
goods[949] =new setGoods("0000a58209","120","40","72","40","bp","normal","86000");
goods[950] =new setGoods("0000a58210","130","40","72","40","bp","normal","86000");
goods[951] =new setGoods("0000a58211","140","40","72","40","bp","normal","88000");
goods[952] =new setGoods("0000a58212","150","40","72","40","bp","normal","88000");
goods[953] =new setGoods("0000a58213","60","50","72","40","bp","normal","92000");
goods[954] =new setGoods("0000a58214","70","50","72","40","bp","normal","98000");
goods[955] =new setGoods("0000a58215","80","50","72","40","bp","normal","100000");
goods[956] =new setGoods("0000a58216","90","50","72","40","bp","normal","103000");
goods[957] =new setGoods("0000a58217","100","50","72","40","bp","normal","122000");
goods[958] =new setGoods("0000a58218","110","50","72","40","bp","normal","124000");
goods[959] =new setGoods("0000a58219","120","50","72","40","bp","normal","128000");
goods[960] =new setGoods("0000a58220","130","50","72","40","bp","normal","130000");
goods[961] =new setGoods("0000a58221","140","50","72","40","bp","normal","130000");
goods[962] =new setGoods("0000a58222","150","50","72","40","bp","normal","131000");
goods[963] =new setGoods("0000a58223","70","60","72","40","bp","normal","104000");
goods[964] =new setGoods("0000a58224","80","60","72","40","bp","normal","105000");
goods[965] =new setGoods("0000a58225","90","60","72","40","bp","normal","106000");
goods[966] =new setGoods("0000a58226","100","60","72","40","bp","normal","126000");
goods[967] =new setGoods("0000a58227","110","60","72","40","bp","normal","128000");
goods[968] =new setGoods("0000a58228","120","60","72","40","bp","normal","134000");
goods[969] =new setGoods("0000a58229","130","60","72","40","bp","normal","135000");
goods[970] =new setGoods("0000a58230","140","60","72","40","bp","normal","135000");
goods[971] =new setGoods("0000a58231","150","60","72","40","bp","normal","135000");
goods[972] =new setGoods("0000a58232","80","70","72","40","bp","normal","109000");
goods[973] =new setGoods("0000a58233","90","70","72","40","bp","normal","111000");
goods[974] =new setGoods("0000a58234","100","70","72","40","bp","normal","133000");
goods[975] =new setGoods("0000a58235","110","70","72","40","bp","normal","133000");
goods[976] =new setGoods("0000a58236","120","70","72","40","bp","normal","138000");
goods[977] =new setGoods("0000a58237","130","70","72","40","bp","normal","138000");
goods[978] =new setGoods("0000a58238","140","70","72","40","bp","normal","138000");
goods[979] =new setGoods("0000a58239","150","70","72","40","bp","normal","139000");
goods[980] =new setGoods("0000a58240","90","80","72","40","bp","normal","111000");
goods[981] =new setGoods("0000a58241","100","80","72","40","bp","normal","134000");
goods[982] =new setGoods("0000a58242","110","80","72","40","bp","normal","136000");
goods[983] =new setGoods("0000a58243","120","80","72","40","bp","normal","138000");
goods[984] =new setGoods("0000a58244","130","80","72","40","bp","normal","138000");
goods[985] =new setGoods("0000a58245","140","80","72","40","bp","normal","139000");
goods[986] =new setGoods("0000a58246","150","80","72","40","bp","normal","142000");
goods[987] =new setGoods("0000a58247","100","90","72","40","bp","normal","136000");
goods[988] =new setGoods("0000a58248","110","90","72","40","bp","normal","137000");
goods[989] =new setGoods("0000a58249","120","90","72","40","bp","normal","138000");
goods[990] =new setGoods("0000a58250","130","90","72","40","bp","normal","139000");
goods[991] =new setGoods("0000a58251","140","90","72","40","bp","normal","142000");
goods[992] =new setGoods("0000a58252","150","90","72","40","bp","normal","142000");
goods[993] =new setGoods("0000a58253","40","40","72","40","bp","normal","59000");
goods[994] =new setGoods("0000a58254","50","50","72","40","bp","normal","91000");
goods[995] =new setGoods("0000a58255","60","60","72","40","bp","normal","96000");
goods[996] =new setGoods("0000a58256","70","70","72","40","bp","normal","108000");
goods[997] =new setGoods("0000a58257","80","80","72","40","bp","normal","109000");
goods[998] =new setGoods("0000a58258","90","90","72","40","bp","normal","112000");
goods[999] =new setGoods("0000a58259","50","40","90","40","bp","normal","64000");
goods[1000] =new setGoods("0000a58260","60","40","90","40","bp","normal","65000");
goods[1001] =new setGoods("0000a58261","70","40","90","40","bp","normal","69000");
goods[1002] =new setGoods("0000a58262","80","40","90","40","bp","normal","70000");
goods[1003] =new setGoods("0000a58263","90","40","90","40","bp","normal","71000");
goods[1004] =new setGoods("0000a58264","100","40","90","40","bp","normal","81000");
goods[1005] =new setGoods("0000a58265","110","40","90","40","bp","normal","83000");
goods[1006] =new setGoods("0000a58266","120","40","90","40","bp","normal","87000");
goods[1007] =new setGoods("0000a58267","130","40","90","40","bp","normal","87000");
goods[1008] =new setGoods("0000a58268","140","40","90","40","bp","normal","89000");
goods[1009] =new setGoods("0000a58269","150","40","90","40","bp","normal","89000");
goods[1010] =new setGoods("0000a58270","60","50","90","40","bp","normal","94000");
goods[1011] =new setGoods("0000a58271","70","50","90","40","bp","normal","101000");
goods[1012] =new setGoods("0000a58272","80","50","90","40","bp","normal","102000");
goods[1013] =new setGoods("0000a58273","90","50","90","40","bp","normal","104000");
goods[1014] =new setGoods("0000a58274","100","50","90","40","bp","normal","123000");
goods[1015] =new setGoods("0000a58275","110","50","90","40","bp","normal","125000");
goods[1016] =new setGoods("0000a58276","120","50","90","40","bp","normal","130000");
goods[1017] =new setGoods("0000a58277","130","50","90","40","bp","normal","131000");
goods[1018] =new setGoods("0000a58278","140","50","90","40","bp","normal","131000");
goods[1019] =new setGoods("0000a58279","150","50","90","40","bp","normal","132000");
goods[1020] =new setGoods("0000a58280","70","60","90","40","bp","normal","105000");
goods[1021] =new setGoods("0000a58281","80","60","90","40","bp","normal","106000");
goods[1022] =new setGoods("0000a58282","90","60","90","40","bp","normal","108000");
goods[1023] =new setGoods("0000a58283","100","60","90","40","bp","normal","127000");
goods[1024] =new setGoods("0000a58284","110","60","90","40","bp","normal","130000");
goods[1025] =new setGoods("0000a58285","120","60","90","40","bp","normal","135000");
goods[1026] =new setGoods("0000a58286","130","60","90","40","bp","normal","136000");
goods[1027] =new setGoods("0000a58287","140","60","90","40","bp","normal","136000");
goods[1028] =new setGoods("0000a58288","150","60","90","40","bp","normal","136000");
goods[1029] =new setGoods("0000a58289","80","70","90","40","bp","normal","110000");
goods[1030] =new setGoods("0000a58290","90","70","90","40","bp","normal","112000");
goods[1031] =new setGoods("0000a58291","100","70","90","40","bp","normal","134000");
goods[1032] =new setGoods("0000a58292","110","70","90","40","bp","normal","134000");
goods[1033] =new setGoods("0000a58293","120","70","90","40","bp","normal","139000");
goods[1034] =new setGoods("0000a58294","130","70","90","40","bp","normal","139000");
goods[1035] =new setGoods("0000a58295","140","70","90","40","bp","normal","139000");
goods[1036] =new setGoods("0000a58296","150","70","90","40","bp","normal","141000");
goods[1037] =new setGoods("0000a58297","90","80","90","40","bp","normal","112000");
goods[1038] =new setGoods("0000a58298","100","80","90","40","bp","normal","135000");
goods[1039] =new setGoods("0000a58299","110","80","90","40","bp","normal","137000");
goods[1040] =new setGoods("0000a58300","120","80","90","40","bp","normal","139000");
goods[1041] =new setGoods("0000a58301","130","80","90","40","bp","normal","139000");
goods[1042] =new setGoods("0000a58302","140","80","90","40","bp","normal","141000");
goods[1043] =new setGoods("0000a58303","150","80","90","40","bp","normal","143000");
goods[1044] =new setGoods("0000a58304","100","90","90","40","bp","normal","137000");
goods[1045] =new setGoods("0000a58305","110","90","90","40","bp","normal","139000");
goods[1046] =new setGoods("0000a58306","120","90","90","40","bp","normal","139000");
goods[1047] =new setGoods("0000a58307","130","90","90","40","bp","normal","141000");
goods[1048] =new setGoods("0000a58308","140","90","90","40","bp","normal","143000");
goods[1049] =new setGoods("0000a58309","150","90","90","40","bp","normal","143000");
goods[1050] =new setGoods("0000a58310","40","40","90","40","bp","normal","61000");
goods[1051] =new setGoods("0000a58311","50","50","90","40","bp","normal","93000");
goods[1052] =new setGoods("0000a58312","60","60","90","40","bp","normal","98000");
goods[1053] =new setGoods("0000a58313","70","70","90","40","bp","normal","109000");
goods[1054] =new setGoods("0000a58314","80","80","90","40","bp","normal","110000");
goods[1055] =new setGoods("0000a58315","90","90","90","40","bp","normal","113000");
goods[1056] =new setGoods("0000a58316","40","30","42","40","mb","normal","38000");
goods[1057] =new setGoods("0000a58317","50","30","42","40","mb","normal","40000");
goods[1058] =new setGoods("0000a58318","60","30","42","40","mb","normal","40000");
goods[1059] =new setGoods("0000a58319","70","30","42","40","mb","normal","42000");
goods[1060] =new setGoods("0000a58320","80","30","42","40","mb","normal","43000");
goods[1061] =new setGoods("0000a58321","90","30","42","40","mb","normal","44000");
goods[1062] =new setGoods("0000a58322","100","30","42","40","mb","normal","51000");
goods[1063] =new setGoods("0000a58323","110","30","42","40","mb","normal","55000");
goods[1064] =new setGoods("0000a58324","120","30","42","40","mb","normal","58000");
goods[1065] =new setGoods("0000a58325","130","30","42","40","mb","normal","59000");
goods[1066] =new setGoods("0000a58326","140","30","42","40","mb","normal","59000");
goods[1067] =new setGoods("0000a58327","150","30","42","40","mb","normal","60000");
goods[1068] =new setGoods("0000a58328","50","40","42","40","mb","normal","50000");
goods[1069] =new setGoods("0000a58329","60","40","42","40","mb","normal","49000");
goods[1070] =new setGoods("0000a58330","70","40","42","40","mb","normal","53000");
goods[1071] =new setGoods("0000a58331","80","40","42","40","mb","normal","54000");
goods[1072] =new setGoods("0000a58332","90","40","42","40","mb","normal","55000");
goods[1073] =new setGoods("0000a58333","100","40","42","40","mb","normal","67000");
goods[1074] =new setGoods("0000a58334","110","40","42","40","mb","normal","69000");
goods[1075] =new setGoods("0000a58335","120","40","42","40","mb","normal","71000");
goods[1076] =new setGoods("0000a58336","130","40","42","40","mb","normal","72000");
goods[1077] =new setGoods("0000a58337","140","40","42","40","mb","normal","73000");
goods[1078] =new setGoods("0000a58338","150","40","42","40","mb","normal","73000");
goods[1079] =new setGoods("0000a58339","60","50","42","40","mb","normal","73000");
goods[1080] =new setGoods("0000a58340","70","50","42","40","mb","normal","77000");
goods[1081] =new setGoods("0000a58341","80","50","42","40","mb","normal","80000");
goods[1082] =new setGoods("0000a58342","90","50","42","40","mb","normal","82000");
goods[1083] =new setGoods("0000a58343","100","50","42","40","mb","normal","101000");
goods[1084] =new setGoods("0000a58344","110","50","42","40","mb","normal","103000");
goods[1085] =new setGoods("0000a58345","120","50","42","40","mb","normal","108000");
goods[1086] =new setGoods("0000a58346","130","50","42","40","mb","normal","109000");
goods[1087] =new setGoods("0000a58347","140","50","42","40","mb","normal","109000");
goods[1088] =new setGoods("0000a58348","150","50","42","40","mb","normal","110000");
goods[1089] =new setGoods("0000a58349","70","60","42","40","mb","normal","87000");
goods[1090] =new setGoods("0000a58350","80","60","42","40","mb","normal","89000");
goods[1091] =new setGoods("0000a58351","90","60","42","40","mb","normal","86000");
goods[1092] =new setGoods("0000a58352","100","60","42","40","mb","normal","105000");
goods[1093] =new setGoods("0000a58353","110","60","42","40","mb","normal","108000");
goods[1094] =new setGoods("0000a58354","120","60","42","40","mb","normal","113000");
goods[1095] =new setGoods("0000a58355","130","60","42","40","mb","normal","113000");
goods[1096] =new setGoods("0000a58356","140","60","42","40","mb","normal","114000");
goods[1097] =new setGoods("0000a58357","150","60","42","40","mb","normal","114000");
goods[1098] =new setGoods("0000a58358","80","70","42","40","mb","normal","91000");
goods[1099] =new setGoods("0000a58359","90","70","42","40","mb","normal","93000");
goods[1100] =new setGoods("0000a58360","100","70","42","40","mb","normal","108000");
goods[1101] =new setGoods("0000a58361","110","70","42","40","mb","normal","111000");
goods[1102] =new setGoods("0000a58362","120","70","42","40","mb","normal","116000");
goods[1103] =new setGoods("0000a58363","130","70","42","40","mb","normal","116000");
goods[1104] =new setGoods("0000a58364","140","70","42","40","mb","normal","116000");
goods[1105] =new setGoods("0000a58365","150","70","42","40","mb","normal","116000");
goods[1106] =new setGoods("0000a58366","90","80","42","40","mb","normal","93000");
goods[1107] =new setGoods("0000a58367","100","80","42","40","mb","normal","109000");
goods[1108] =new setGoods("0000a58368","110","80","42","40","mb","normal","111000");
goods[1109] =new setGoods("0000a58369","120","80","42","40","mb","normal","116000");
goods[1110] =new setGoods("0000a58370","130","80","42","40","mb","normal","116000");
goods[1111] =new setGoods("0000a58371","140","80","42","40","mb","normal","116000");
goods[1112] =new setGoods("0000a58372","150","80","42","40","mb","normal","120000");
goods[1113] =new setGoods("0000a58373","100","90","42","40","mb","normal","110000");
goods[1114] =new setGoods("0000a58374","110","90","42","40","mb","normal","112000");
goods[1115] =new setGoods("0000a58375","120","90","42","40","mb","normal","116000");
goods[1116] =new setGoods("0000a58376","130","90","42","40","mb","normal","116000");
goods[1117] =new setGoods("0000a58377","140","90","42","40","mb","normal","120000");
goods[1118] =new setGoods("0000a58378","150","90","42","40","mb","normal","120000");
goods[1119] =new setGoods("0000a58379","40","40","42","40","mb","normal","46000");
goods[1120] =new setGoods("0000a58380","50","50","42","40","mb","normal","70000");
goods[1121] =new setGoods("0000a58381","60","60","42","40","mb","normal","74000");
goods[1122] =new setGoods("0000a58382","70","70","42","40","mb","normal","86000");
goods[1123] =new setGoods("0000a58383","80","80","42","40","mb","normal","87000");
goods[1124] =new setGoods("0000a58384","90","90","42","40","mb","normal","103000");
goods[1125] =new setGoods("0000a58385","40","30","60","40","mb","normal","43000");
goods[1126] =new setGoods("0000a58386","50","30","60","40","mb","normal","46000");
goods[1127] =new setGoods("0000a58387","60","30","60","40","mb","normal","46000");
goods[1128] =new setGoods("0000a58388","70","30","60","40","mb","normal","48000");
goods[1129] =new setGoods("0000a58389","80","30","60","40","mb","normal","49000");
goods[1130] =new setGoods("0000a58390","90","30","60","40","mb","normal","50000");
goods[1131] =new setGoods("0000a58391","100","30","60","40","mb","normal","58000");
goods[1132] =new setGoods("0000a58392","110","30","60","40","mb","normal","60000");
goods[1133] =new setGoods("0000a58393","120","30","60","40","mb","normal","64000");
goods[1134] =new setGoods("0000a58394","130","30","60","40","mb","normal","65000");
goods[1135] =new setGoods("0000a58395","140","30","60","40","mb","normal","65000");
goods[1136] =new setGoods("0000a58396","150","30","60","40","mb","normal","66000");
goods[1137] =new setGoods("0000a58397","50","40","60","40","mb","normal","57000");
goods[1138] =new setGoods("0000a58398","60","40","60","40","mb","normal","55000");
goods[1139] =new setGoods("0000a58399","70","40","60","40","mb","normal","60000");
goods[1140] =new setGoods("0000a58400","80","40","60","40","mb","normal","61000");
goods[1141] =new setGoods("0000a58401","90","40","60","40","mb","normal","63000");
goods[1142] =new setGoods("0000a58402","100","40","60","40","mb","normal","73000");
goods[1143] =new setGoods("0000a58403","110","40","60","40","mb","normal","76000");
goods[1144] =new setGoods("0000a58404","120","40","60","40","mb","normal","79000");
goods[1145] =new setGoods("0000a58405","130","40","60","40","mb","normal","79000");
goods[1146] =new setGoods("0000a58406","140","40","60","40","mb","normal","80000");
goods[1147] =new setGoods("0000a58407","150","40","60","40","mb","normal","80000");
goods[1148] =new setGoods("0000a58408","60","50","60","40","mb","normal","84000");
goods[1149] =new setGoods("0000a58409","70","50","60","40","mb","normal","88000");
goods[1150] =new setGoods("0000a58410","80","50","60","40","mb","normal","91000");
goods[1151] =new setGoods("0000a58411","90","50","60","40","mb","normal","92000");
goods[1152] =new setGoods("0000a58412","100","50","60","40","mb","normal","112000");
goods[1153] =new setGoods("0000a58413","110","50","60","40","mb","normal","114000");
goods[1154] =new setGoods("0000a58414","120","50","60","40","mb","normal","117000");
goods[1155] =new setGoods("0000a58415","130","50","60","40","mb","normal","120000");
goods[1156] =new setGoods("0000a58416","140","50","60","40","mb","normal","120000");
goods[1157] =new setGoods("0000a58417","150","50","60","40","mb","normal","120000");
goods[1158] =new setGoods("0000a58418","70","60","60","40","mb","normal","98000");
goods[1159] =new setGoods("0000a58419","80","60","60","40","mb","normal","100000");
goods[1160] =new setGoods("0000a58420","90","60","60","40","mb","normal","97000");
goods[1161] =new setGoods("0000a58421","100","60","60","40","mb","normal","115000");
goods[1162] =new setGoods("0000a58422","110","60","60","40","mb","normal","117000");
goods[1163] =new setGoods("0000a58423","120","60","60","40","mb","normal","124000");
goods[1164] =new setGoods("0000a58424","130","60","60","40","mb","normal","124000");
goods[1165] =new setGoods("0000a58425","140","60","60","40","mb","normal","124000");
goods[1166] =new setGoods("0000a58426","150","60","60","40","mb","normal","125000");
goods[1167] =new setGoods("0000a58427","80","70","60","40","mb","normal","102000");
goods[1168] =new setGoods("0000a58428","90","70","60","40","mb","normal","104000");
goods[1169] =new setGoods("0000a58429","100","70","60","40","mb","normal","117000");
goods[1170] =new setGoods("0000a58430","110","70","60","40","mb","normal","119000");
goods[1171] =new setGoods("0000a58431","120","70","60","40","mb","normal","119000");
goods[1172] =new setGoods("0000a58432","130","70","60","40","mb","normal","119000");
goods[1173] =new setGoods("0000a58433","140","70","60","40","mb","normal","119000");
goods[1174] =new setGoods("0000a58434","150","70","60","40","mb","normal","119000");
goods[1175] =new setGoods("0000a58435","90","80","60","40","mb","normal","117000");
goods[1176] =new setGoods("0000a58436","100","80","60","40","mb","normal","119000");
goods[1177] =new setGoods("0000a58437","110","80","60","40","mb","normal","122000");
goods[1178] =new setGoods("0000a58438","120","80","60","40","mb","normal","127000");
goods[1179] =new setGoods("0000a58439","130","80","60","40","mb","normal","127000");
goods[1180] =new setGoods("0000a58440","140","80","60","40","mb","normal","128000");
goods[1181] =new setGoods("0000a58441","150","80","60","40","mb","normal","131000");
goods[1182] =new setGoods("0000a58442","100","90","60","40","mb","normal","121000");
goods[1183] =new setGoods("0000a58443","110","90","60","40","mb","normal","123000");
goods[1184] =new setGoods("0000a58444","120","90","60","40","mb","normal","127000");
goods[1185] =new setGoods("0000a58445","130","90","60","40","mb","normal","128000");
goods[1186] =new setGoods("0000a58446","140","90","60","40","mb","normal","131000");
goods[1187] =new setGoods("0000a58447","150","90","60","40","mb","normal","131000");
goods[1188] =new setGoods("0000a58448","40","40","60","40","mb","normal","52000");
goods[1189] =new setGoods("0000a58449","50","50","60","40","mb","normal","80000");
goods[1190] =new setGoods("0000a58450","60","60","60","40","mb","normal","85000");
goods[1191] =new setGoods("0000a58451","70","70","60","40","mb","normal","97000");
goods[1192] =new setGoods("0000a58452","80","80","60","40","mb","normal","98000");
goods[1193] =new setGoods("0000a58453","90","90","60","40","mb","normal","119000");
goods[1194] =new setGoods("0000a58454","40","30","72","40","mb","normal","52000");
goods[1195] =new setGoods("0000a58455","50","30","72","40","mb","normal","54000");
goods[1196] =new setGoods("0000a58456","60","30","72","40","mb","normal","54000");
goods[1197] =new setGoods("0000a58457","70","30","72","40","mb","normal","57000");
goods[1198] =new setGoods("0000a58458","80","30","72","40","mb","normal","58000");
goods[1199] =new setGoods("0000a58459","90","30","72","40","mb","normal","59000");
goods[1200] =new setGoods("0000a58460","100","30","72","40","mb","normal","66000");
goods[1201] =new setGoods("0000a58461","110","30","72","40","mb","normal","69000");
goods[1202] =new setGoods("0000a58462","120","30","72","40","mb","normal","72000");
goods[1203] =new setGoods("0000a58463","130","30","72","40","mb","normal","73000");
goods[1204] =new setGoods("0000a58464","140","30","72","40","mb","normal","73000");
goods[1205] =new setGoods("0000a58465","150","30","72","40","mb","normal","75000");
goods[1206] =new setGoods("0000a58466","50","40","72","40","mb","normal","68000");
goods[1207] =new setGoods("0000a58467","60","40","72","40","mb","normal","68000");
goods[1208] =new setGoods("0000a58468","70","40","72","40","mb","normal","71000");
goods[1209] =new setGoods("0000a58469","80","40","72","40","mb","normal","72000");
goods[1210] =new setGoods("0000a58470","90","40","72","40","mb","normal","74000");
goods[1211] =new setGoods("0000a58471","100","40","72","40","mb","normal","84000");
goods[1212] =new setGoods("0000a58472","110","40","72","40","mb","normal","87000");
goods[1213] =new setGoods("0000a58473","120","40","72","40","mb","normal","90000");
goods[1214] =new setGoods("0000a58474","130","40","72","40","mb","normal","90000");
goods[1215] =new setGoods("0000a58475","140","40","72","40","mb","normal","91000");
goods[1216] =new setGoods("0000a58476","150","40","72","40","mb","normal","92000");
goods[1217] =new setGoods("0000a58477","60","50","72","40","mb","normal","104000");
goods[1218] =new setGoods("0000a58478","70","50","72","40","mb","normal","107000");
goods[1219] =new setGoods("0000a58479","80","50","72","40","mb","normal","109000");
goods[1220] =new setGoods("0000a58480","90","50","72","40","mb","normal","112000");
goods[1221] =new setGoods("0000a58481","100","50","72","40","mb","normal","131000");
goods[1222] =new setGoods("0000a58482","110","50","72","40","mb","normal","133000");
goods[1223] =new setGoods("0000a58483","120","50","72","40","mb","normal","137000");
goods[1224] =new setGoods("0000a58484","130","50","72","40","mb","normal","138000");
goods[1225] =new setGoods("0000a58485","140","50","72","40","mb","normal","138000");
goods[1226] =new setGoods("0000a58486","150","50","72","40","mb","normal","139000");
goods[1227] =new setGoods("0000a58487","70","60","72","40","mb","normal","117000");
goods[1228] =new setGoods("0000a58488","80","60","72","40","mb","normal","119000");
goods[1229] =new setGoods("0000a58489","90","60","72","40","mb","normal","115000");
goods[1230] =new setGoods("0000a58490","100","60","72","40","mb","normal","135000");
goods[1231] =new setGoods("0000a58491","110","60","72","40","mb","normal","137000");
goods[1232] =new setGoods("0000a58492","120","60","72","40","mb","normal","143000");
goods[1233] =new setGoods("0000a58493","130","60","72","40","mb","normal","143000");
goods[1234] =new setGoods("0000a58494","140","60","72","40","mb","normal","144000");
goods[1235] =new setGoods("0000a58495","150","60","72","40","mb","normal","144000");
goods[1236] =new setGoods("0000a58496","80","70","72","40","mb","normal","122000");
goods[1237] =new setGoods("0000a58497","90","70","72","40","mb","normal","124000");
goods[1238] =new setGoods("0000a58498","100","70","72","40","mb","normal","137000");
goods[1239] =new setGoods("0000a58499","110","70","72","40","mb","normal","138000");
goods[1240] =new setGoods("0000a58500","120","70","72","40","mb","normal","138000");
goods[1241] =new setGoods("0000a58501","130","70","72","40","mb","normal","138000");
goods[1242] =new setGoods("0000a58502","140","70","72","40","mb","normal","138000");
goods[1243] =new setGoods("0000a58503","150","70","72","40","mb","normal","138000");
goods[1244] =new setGoods("0000a58504","90","80","72","40","mb","normal","137000");
goods[1245] =new setGoods("0000a58505","100","80","72","40","mb","normal","138000");
goods[1246] =new setGoods("0000a58506","110","80","72","40","mb","normal","142000");
goods[1247] =new setGoods("0000a58507","120","80","72","40","mb","normal","147000");
goods[1248] =new setGoods("0000a58508","130","80","72","40","mb","normal","147000");
goods[1249] =new setGoods("0000a58509","140","80","72","40","mb","normal","148000");
goods[1250] =new setGoods("0000a58510","150","80","72","40","mb","normal","150000");
goods[1251] =new setGoods("0000a58511","100","90","72","40","mb","normal","141000");
goods[1252] =new setGoods("0000a58512","110","90","72","40","mb","normal","143000");
goods[1253] =new setGoods("0000a58513","120","90","72","40","mb","normal","147000");
goods[1254] =new setGoods("0000a58514","130","90","72","40","mb","normal","148000");
goods[1255] =new setGoods("0000a58515","140","90","72","40","mb","normal","150000");
goods[1256] =new setGoods("0000a58516","150","90","72","40","mb","normal","150000");
goods[1257] =new setGoods("0000a58517","40","40","72","40","mb","normal","63000");
goods[1258] =new setGoods("0000a58518","50","50","72","40","mb","normal","99000");
goods[1259] =new setGoods("0000a58519","60","60","72","40","mb","normal","105000");
goods[1260] =new setGoods("0000a58520","70","70","72","40","mb","normal","116000");
goods[1261] =new setGoods("0000a58521","80","80","72","40","mb","normal","117000");
goods[1262] =new setGoods("0000a58522","90","90","72","40","mb","normal","138000");
goods[1263] =new setGoods("0000a58523","50","40","90","40","mb","normal","70000");
goods[1264] =new setGoods("0000a58524","60","40","90","40","mb","normal","70000");
goods[1265] =new setGoods("0000a58525","70","40","90","40","mb","normal","73000");
goods[1266] =new setGoods("0000a58526","80","40","90","40","mb","normal","74000");
goods[1267] =new setGoods("0000a58527","90","40","90","40","mb","normal","75000");
goods[1268] =new setGoods("0000a58528","100","40","90","40","mb","normal","86000");
goods[1269] =new setGoods("0000a58529","110","40","90","40","mb","normal","88000");
goods[1270] =new setGoods("0000a58530","120","40","90","40","mb","normal","91000");
goods[1271] =new setGoods("0000a58531","130","40","90","40","mb","normal","91000");
goods[1272] =new setGoods("0000a58532","140","40","90","40","mb","normal","92000");
goods[1273] =new setGoods("0000a58533","150","40","90","40","mb","normal","93000");
goods[1274] =new setGoods("0000a58534","60","50","90","40","mb","normal","103000");
goods[1275] =new setGoods("0000a58535","70","50","90","40","mb","normal","110000");
goods[1276] =new setGoods("0000a58536","80","50","90","40","mb","normal","111000");
goods[1277] =new setGoods("0000a58537","90","50","90","40","mb","normal","113000");
goods[1278] =new setGoods("0000a58538","100","50","90","40","mb","normal","132000");
goods[1279] =new setGoods("0000a58539","110","50","90","40","mb","normal","134000");
goods[1280] =new setGoods("0000a58540","120","50","90","40","mb","normal","138000");
goods[1281] =new setGoods("0000a58541","130","50","90","40","mb","normal","139000");
goods[1282] =new setGoods("0000a58542","140","50","90","40","mb","normal","139000");
goods[1283] =new setGoods("0000a58543","150","50","90","40","mb","normal","141000");
goods[1284] =new setGoods("0000a58544","70","60","90","40","mb","normal","114000");
goods[1285] =new setGoods("0000a58545","80","60","90","40","mb","normal","115000");
goods[1286] =new setGoods("0000a58546","90","60","90","40","mb","normal","116000");
goods[1287] =new setGoods("0000a58547","100","60","90","40","mb","normal","136000");
goods[1288] =new setGoods("0000a58548","110","60","90","40","mb","normal","138000");
goods[1289] =new setGoods("0000a58549","120","60","90","40","mb","normal","144000");
goods[1290] =new setGoods("0000a58550","130","60","90","40","mb","normal","144000");
goods[1291] =new setGoods("0000a58551","140","60","90","40","mb","normal","145000");
goods[1292] =new setGoods("0000a58552","150","60","90","40","mb","normal","145000");
goods[1293] =new setGoods("0000a58553","80","70","90","40","mb","normal","119000");
goods[1294] =new setGoods("0000a58554","90","70","90","40","mb","normal","127000");
goods[1295] =new setGoods("0000a58555","100","70","90","40","mb","normal","139000");
goods[1296] =new setGoods("0000a58556","110","70","90","40","mb","normal","143000");
goods[1297] =new setGoods("0000a58557","120","70","90","40","mb","normal","148000");
goods[1298] =new setGoods("0000a58558","130","70","90","40","mb","normal","148000");
goods[1299] =new setGoods("0000a58559","140","70","90","40","mb","normal","148000");
goods[1300] =new setGoods("0000a58560","150","70","90","40","mb","normal","149000");
goods[1301] =new setGoods("0000a58561","90","80","90","40","mb","normal","139000");
goods[1302] =new setGoods("0000a58562","100","80","90","40","mb","normal","141000");
goods[1303] =new setGoods("0000a58563","110","80","90","40","mb","normal","143000");
goods[1304] =new setGoods("0000a58564","120","80","90","40","mb","normal","148000");
goods[1305] =new setGoods("0000a58565","130","80","90","40","mb","normal","148000");
goods[1306] =new setGoods("0000a58566","140","80","90","40","mb","normal","149000");
goods[1307] =new setGoods("0000a58567","150","80","90","40","mb","normal","151000");
goods[1308] =new setGoods("0000a58568","100","90","90","40","mb","normal","142000");
goods[1309] =new setGoods("0000a58569","110","90","90","40","mb","normal","144000");
goods[1310] =new setGoods("0000a58570","120","90","90","40","mb","normal","148000");
goods[1311] =new setGoods("0000a58571","130","90","90","40","mb","normal","149000");
goods[1312] =new setGoods("0000a58572","140","90","90","40","mb","normal","151000");
goods[1313] =new setGoods("0000a58573","150","90","90","40","mb","normal","151000");
goods[1314] =new setGoods("0000a58574","40","40","90","40","mb","normal","65000");
goods[1315] =new setGoods("0000a58575","50","50","90","40","mb","normal","102000");
goods[1316] =new setGoods("0000a58576","60","60","90","40","mb","normal","106000");
goods[1317] =new setGoods("0000a58577","70","70","90","40","mb","normal","117000");
goods[1318] =new setGoods("0000a58578","80","80","90","40","mb","normal","119000");
goods[1319] =new setGoods("0000a58579","90","90","90","40","mb","normal","141000");
goods[1320] =new setGoods("0000a58580","40","30","42","40","gs","normal","38000");
goods[1321] =new setGoods("0000a58581","50","30","42","40","gs","normal","40000");
goods[1322] =new setGoods("0000a58582","60","30","42","40","gs","normal","40000");
goods[1323] =new setGoods("0000a58583","70","30","42","40","gs","normal","42000");
goods[1324] =new setGoods("0000a58584","80","30","42","40","gs","normal","43000");
goods[1325] =new setGoods("0000a58585","90","30","42","40","gs","normal","44000");
goods[1326] =new setGoods("0000a58586","100","30","42","40","gs","normal","51000");
goods[1327] =new setGoods("0000a58587","110","30","42","40","gs","normal","55000");
goods[1328] =new setGoods("0000a58588","120","30","42","40","gs","normal","58000");
goods[1329] =new setGoods("0000a58589","130","30","42","40","gs","normal","59000");
goods[1330] =new setGoods("0000a58590","140","30","42","40","gs","normal","59000");
goods[1331] =new setGoods("0000a58591","150","30","42","40","gs","normal","60000");
goods[1332] =new setGoods("0000a58592","50","40","42","40","gs","normal","50000");
goods[1333] =new setGoods("0000a58593","60","40","42","40","gs","normal","49000");
goods[1334] =new setGoods("0000a58594","70","40","42","40","gs","normal","53000");
goods[1335] =new setGoods("0000a58595","80","40","42","40","gs","normal","54000");
goods[1336] =new setGoods("0000a58596","90","40","42","40","gs","normal","55000");
goods[1337] =new setGoods("0000a58597","100","40","42","40","gs","normal","67000");
goods[1338] =new setGoods("0000a58598","110","40","42","40","gs","normal","69000");
goods[1339] =new setGoods("0000a58599","120","40","42","40","gs","normal","71000");
goods[1340] =new setGoods("0000a58600","130","40","42","40","gs","normal","72000");
goods[1341] =new setGoods("0000a58601","140","40","42","40","gs","normal","73000");
goods[1342] =new setGoods("0000a58602","150","40","42","40","gs","normal","73000");
goods[1343] =new setGoods("0000a58603","60","50","42","40","gs","normal","73000");
goods[1344] =new setGoods("0000a58604","70","50","42","40","gs","normal","77000");
goods[1345] =new setGoods("0000a58605","80","50","42","40","gs","normal","80000");
goods[1346] =new setGoods("0000a58606","90","50","42","40","gs","normal","82000");
goods[1347] =new setGoods("0000a58607","100","50","42","40","gs","normal","101000");
goods[1348] =new setGoods("0000a58608","110","50","42","40","gs","normal","103000");
goods[1349] =new setGoods("0000a58609","120","50","42","40","gs","normal","108000");
goods[1350] =new setGoods("0000a58610","130","50","42","40","gs","normal","109000");
goods[1351] =new setGoods("0000a58611","140","50","42","40","gs","normal","109000");
goods[1352] =new setGoods("0000a58612","150","50","42","40","gs","normal","110000");
goods[1353] =new setGoods("0000a58613","70","60","42","40","gs","normal","87000");
goods[1354] =new setGoods("0000a58614","80","60","42","40","gs","normal","89000");
goods[1355] =new setGoods("0000a58615","90","60","42","40","gs","normal","86000");
goods[1356] =new setGoods("0000a58616","100","60","42","40","gs","normal","105000");
goods[1357] =new setGoods("0000a58617","110","60","42","40","gs","normal","108000");
goods[1358] =new setGoods("0000a58618","120","60","42","40","gs","normal","113000");
goods[1359] =new setGoods("0000a58619","130","60","42","40","gs","normal","113000");
goods[1360] =new setGoods("0000a58620","140","60","42","40","gs","normal","114000");
goods[1361] =new setGoods("0000a58621","150","60","42","40","gs","normal","114000");
goods[1362] =new setGoods("0000a58622","80","70","42","40","gs","normal","91000");
goods[1363] =new setGoods("0000a58623","90","70","42","40","gs","normal","93000");
goods[1364] =new setGoods("0000a58624","100","70","42","40","gs","normal","108000");
goods[1365] =new setGoods("0000a58625","110","70","42","40","gs","normal","111000");
goods[1366] =new setGoods("0000a58626","120","70","42","40","gs","normal","116000");
goods[1367] =new setGoods("0000a58627","130","70","42","40","gs","normal","116000");
goods[1368] =new setGoods("0000a58628","140","70","42","40","gs","normal","116000");
goods[1369] =new setGoods("0000a58629","150","70","42","40","gs","normal","116000");
goods[1370] =new setGoods("0000a58630","90","80","42","40","gs","normal","93000");
goods[1371] =new setGoods("0000a58631","100","80","42","40","gs","normal","109000");
goods[1372] =new setGoods("0000a58632","110","80","42","40","gs","normal","111000");
goods[1373] =new setGoods("0000a58633","120","80","42","40","gs","normal","116000");
goods[1374] =new setGoods("0000a58634","130","80","42","40","gs","normal","116000");
goods[1375] =new setGoods("0000a58635","140","80","42","40","gs","normal","116000");
goods[1376] =new setGoods("0000a58636","150","80","42","40","gs","normal","120000");
goods[1377] =new setGoods("0000a58637","100","90","42","40","gs","normal","110000");
goods[1378] =new setGoods("0000a58638","110","90","42","40","gs","normal","112000");
goods[1379] =new setGoods("0000a58639","120","90","42","40","gs","normal","116000");
goods[1380] =new setGoods("0000a58640","130","90","42","40","gs","normal","116000");
goods[1381] =new setGoods("0000a58641","140","90","42","40","gs","normal","120000");
goods[1382] =new setGoods("0000a58642","150","90","42","40","gs","normal","120000");
goods[1383] =new setGoods("0000a58643","40","40","42","40","gs","normal","46000");
goods[1384] =new setGoods("0000a58644","50","50","42","40","gs","normal","70000");
goods[1385] =new setGoods("0000a58645","60","60","42","40","gs","normal","74000");
goods[1386] =new setGoods("0000a58646","70","70","42","40","gs","normal","86000");
goods[1387] =new setGoods("0000a58647","80","80","42","40","gs","normal","87000");
goods[1388] =new setGoods("0000a58648","90","90","42","40","gs","normal","103000");
goods[1389] =new setGoods("0000a58649","40","30","60","40","gs","normal","43000");
goods[1390] =new setGoods("0000a58650","50","30","60","40","gs","normal","46000");
goods[1391] =new setGoods("0000a58651","60","30","60","40","gs","normal","46000");
goods[1392] =new setGoods("0000a58652","70","30","60","40","gs","normal","48000");
goods[1393] =new setGoods("0000a58653","80","30","60","40","gs","normal","49000");
goods[1394] =new setGoods("0000a58654","90","30","60","40","gs","normal","50000");
goods[1395] =new setGoods("0000a58655","100","30","60","40","gs","normal","58000");
goods[1396] =new setGoods("0000a58656","110","30","60","40","gs","normal","60000");
goods[1397] =new setGoods("0000a58657","120","30","60","40","gs","normal","64000");
goods[1398] =new setGoods("0000a58658","130","30","60","40","gs","normal","65000");
goods[1399] =new setGoods("0000a58659","140","30","60","40","gs","normal","65000");
goods[1400] =new setGoods("0000a58660","150","30","60","40","gs","normal","66000");
goods[1401] =new setGoods("0000a58661","50","40","60","40","gs","normal","57000");
goods[1402] =new setGoods("0000a58662","60","40","60","40","gs","normal","55000");
goods[1403] =new setGoods("0000a58663","70","40","60","40","gs","normal","60000");
goods[1404] =new setGoods("0000a58664","80","40","60","40","gs","normal","61000");
goods[1405] =new setGoods("0000a58665","90","40","60","40","gs","normal","63000");
goods[1406] =new setGoods("0000a58666","100","40","60","40","gs","normal","73000");
goods[1407] =new setGoods("0000a58667","110","40","60","40","gs","normal","76000");
goods[1408] =new setGoods("0000a58668","120","40","60","40","gs","normal","79000");
goods[1409] =new setGoods("0000a58669","130","40","60","40","gs","normal","79000");
goods[1410] =new setGoods("0000a58670","140","40","60","40","gs","normal","80000");
goods[1411] =new setGoods("0000a58671","150","40","60","40","gs","normal","80000");
goods[1412] =new setGoods("0000a58672","60","50","60","40","gs","normal","84000");
goods[1413] =new setGoods("0000a58673","70","50","60","40","gs","normal","88000");
goods[1414] =new setGoods("0000a58674","80","50","60","40","gs","normal","91000");
goods[1415] =new setGoods("0000a58675","90","50","60","40","gs","normal","92000");
goods[1416] =new setGoods("0000a58676","100","50","60","40","gs","normal","112000");
goods[1417] =new setGoods("0000a58677","110","50","60","40","gs","normal","114000");
goods[1418] =new setGoods("0000a58678","120","50","60","40","gs","normal","117000");
goods[1419] =new setGoods("0000a58679","130","50","60","40","gs","normal","120000");
goods[1420] =new setGoods("0000a58680","140","50","60","40","gs","normal","120000");
goods[1421] =new setGoods("0000a58681","150","50","60","40","gs","normal","120000");
goods[1422] =new setGoods("0000a58682","70","60","60","40","gs","normal","98000");
goods[1423] =new setGoods("0000a58683","80","60","60","40","gs","normal","100000");
goods[1424] =new setGoods("0000a58684","90","60","60","40","gs","normal","97000");
goods[1425] =new setGoods("0000a58685","100","60","60","40","gs","normal","115000");
goods[1426] =new setGoods("0000a58686","110","60","60","40","gs","normal","117000");
goods[1427] =new setGoods("0000a58687","120","60","60","40","gs","normal","124000");
goods[1428] =new setGoods("0000a58688","130","60","60","40","gs","normal","124000");
goods[1429] =new setGoods("0000a58689","140","60","60","40","gs","normal","124000");
goods[1430] =new setGoods("0000a58690","150","60","60","40","gs","normal","125000");
goods[1431] =new setGoods("0000a58691","80","70","60","40","gs","normal","102000");
goods[1432] =new setGoods("0000a58692","90","70","60","40","gs","normal","104000");
goods[1433] =new setGoods("0000a58693","100","70","60","40","gs","normal","117000");
goods[1434] =new setGoods("0000a58694","110","70","60","40","gs","normal","119000");
goods[1435] =new setGoods("0000a58695","120","70","60","40","gs","normal","119000");
goods[1436] =new setGoods("0000a58696","130","70","60","40","gs","normal","119000");
goods[1437] =new setGoods("0000a58697","140","70","60","40","gs","normal","119000");
goods[1438] =new setGoods("0000a58698","150","70","60","40","gs","normal","119000");
goods[1439] =new setGoods("0000a58699","90","80","60","40","gs","normal","117000");
goods[1440] =new setGoods("0000a58700","100","80","60","40","gs","normal","119000");
goods[1441] =new setGoods("0000a58701","110","80","60","40","gs","normal","122000");
goods[1442] =new setGoods("0000a58702","120","80","60","40","gs","normal","127000");
goods[1443] =new setGoods("0000a58703","130","80","60","40","gs","normal","127000");
goods[1444] =new setGoods("0000a58704","140","80","60","40","gs","normal","128000");
goods[1445] =new setGoods("0000a58705","150","80","60","40","gs","normal","131000");
goods[1446] =new setGoods("0000a58706","100","90","60","40","gs","normal","121000");
goods[1447] =new setGoods("0000a58707","110","90","60","40","gs","normal","123000");
goods[1448] =new setGoods("0000a58708","120","90","60","40","gs","normal","127000");
goods[1449] =new setGoods("0000a58709","130","90","60","40","gs","normal","128000");
goods[1450] =new setGoods("0000a58710","140","90","60","40","gs","normal","131000");
goods[1451] =new setGoods("0000a58711","150","90","60","40","gs","normal","131000");
goods[1452] =new setGoods("0000a58712","40","40","60","40","gs","normal","52000");
goods[1453] =new setGoods("0000a58713","50","50","60","40","gs","normal","80000");
goods[1454] =new setGoods("0000a58714","60","60","60","40","gs","normal","85000");
goods[1455] =new setGoods("0000a58715","70","70","60","40","gs","normal","97000");
goods[1456] =new setGoods("0000a58716","80","80","60","40","gs","normal","98000");
goods[1457] =new setGoods("0000a58717","90","90","60","40","gs","normal","119000");
goods[1458] =new setGoods("0000a58718","40","30","72","40","gs","normal","52000");
goods[1459] =new setGoods("0000a58719","50","30","72","40","gs","normal","54000");
goods[1460] =new setGoods("0000a58720","60","30","72","40","gs","normal","54000");
goods[1461] =new setGoods("0000a58721","70","30","72","40","gs","normal","57000");
goods[1462] =new setGoods("0000a58722","80","30","72","40","gs","normal","58000");
goods[1463] =new setGoods("0000a58723","90","30","72","40","gs","normal","59000");
goods[1464] =new setGoods("0000a58724","100","30","72","40","gs","normal","66000");
goods[1465] =new setGoods("0000a58725","110","30","72","40","gs","normal","69000");
goods[1466] =new setGoods("0000a58726","120","30","72","40","gs","normal","72000");
goods[1467] =new setGoods("0000a58727","130","30","72","40","gs","normal","73000");
goods[1468] =new setGoods("0000a58728","140","30","72","40","gs","normal","73000");
goods[1469] =new setGoods("0000a58729","150","30","72","40","gs","normal","75000");
goods[1470] =new setGoods("0000a58730","50","40","72","40","gs","normal","68000");
goods[1471] =new setGoods("0000a58731","60","40","72","40","gs","normal","68000");
goods[1472] =new setGoods("0000a58732","70","40","72","40","gs","normal","71000");
goods[1473] =new setGoods("0000a58733","80","40","72","40","gs","normal","72000");
goods[1474] =new setGoods("0000a58734","90","40","72","40","gs","normal","74000");
goods[1475] =new setGoods("0000a58735","100","40","72","40","gs","normal","84000");
goods[1476] =new setGoods("0000a58736","110","40","72","40","gs","normal","87000");
goods[1477] =new setGoods("0000a58737","120","40","72","40","gs","normal","90000");
goods[1478] =new setGoods("0000a58738","130","40","72","40","gs","normal","90000");
goods[1479] =new setGoods("0000a58739","140","40","72","40","gs","normal","91000");
goods[1480] =new setGoods("0000a58740","150","40","72","40","gs","normal","92000");
goods[1481] =new setGoods("0000a58741","60","50","72","40","gs","normal","104000");
goods[1482] =new setGoods("0000a58742","70","50","72","40","gs","normal","107000");
goods[1483] =new setGoods("0000a58743","80","50","72","40","gs","normal","109000");
goods[1484] =new setGoods("0000a58744","90","50","72","40","gs","normal","112000");
goods[1485] =new setGoods("0000a58745","100","50","72","40","gs","normal","131000");
goods[1486] =new setGoods("0000a58746","110","50","72","40","gs","normal","133000");
goods[1487] =new setGoods("0000a58747","120","50","72","40","gs","normal","137000");
goods[1488] =new setGoods("0000a58748","130","50","72","40","gs","normal","138000");
goods[1489] =new setGoods("0000a58749","140","50","72","40","gs","normal","138000");
goods[1490] =new setGoods("0000a58750","150","50","72","40","gs","normal","139000");
goods[1491] =new setGoods("0000a58751","70","60","72","40","gs","normal","117000");
goods[1492] =new setGoods("0000a58752","80","60","72","40","gs","normal","119000");
goods[1493] =new setGoods("0000a58753","90","60","72","40","gs","normal","115000");
goods[1494] =new setGoods("0000a58754","100","60","72","40","gs","normal","135000");
goods[1495] =new setGoods("0000a58755","110","60","72","40","gs","normal","137000");
goods[1496] =new setGoods("0000a58756","120","60","72","40","gs","normal","143000");
goods[1497] =new setGoods("0000a58757","130","60","72","40","gs","normal","143000");
goods[1498] =new setGoods("0000a58758","140","60","72","40","gs","normal","144000");
goods[1499] =new setGoods("0000a58759","150","60","72","40","gs","normal","144000");
goods[1500] =new setGoods("0000a58760","80","70","72","40","gs","normal","122000");
goods[1501] =new setGoods("0000a58761","90","70","72","40","gs","normal","124000");
goods[1502] =new setGoods("0000a58762","100","70","72","40","gs","normal","137000");
goods[1503] =new setGoods("0000a58763","110","70","72","40","gs","normal","138000");
goods[1504] =new setGoods("0000a58764","120","70","72","40","gs","normal","138000");
goods[1505] =new setGoods("0000a58765","130","70","72","40","gs","normal","138000");
goods[1506] =new setGoods("0000a58766","140","70","72","40","gs","normal","138000");
goods[1507] =new setGoods("0000a58767","150","70","72","40","gs","normal","138000");
goods[1508] =new setGoods("0000a58768","90","80","72","40","gs","normal","137000");
goods[1509] =new setGoods("0000a58769","100","80","72","40","gs","normal","138000");
goods[1510] =new setGoods("0000a58770","110","80","72","40","gs","normal","142000");
goods[1511] =new setGoods("0000a58771","120","80","72","40","gs","normal","147000");
goods[1512] =new setGoods("0000a58772","130","80","72","40","gs","normal","147000");
goods[1513] =new setGoods("0000a58773","140","80","72","40","gs","normal","148000");
goods[1514] =new setGoods("0000a58774","150","80","72","40","gs","normal","150000");
goods[1515] =new setGoods("0000a58775","100","90","72","40","gs","normal","141000");
goods[1516] =new setGoods("0000a58776","110","90","72","40","gs","normal","143000");
goods[1517] =new setGoods("0000a58777","120","90","72","40","gs","normal","147000");
goods[1518] =new setGoods("0000a58778","130","90","72","40","gs","normal","148000");
goods[1519] =new setGoods("0000a58779","140","90","72","40","gs","normal","150000");
goods[1520] =new setGoods("0000a58780","150","90","72","40","gs","normal","150000");
goods[1521] =new setGoods("0000a58781","40","40","72","40","gs","normal","63000");
goods[1522] =new setGoods("0000a58782","50","50","72","40","gs","normal","99000");
goods[1523] =new setGoods("0000a58783","60","60","72","40","gs","normal","105000");
goods[1524] =new setGoods("0000a58784","70","70","72","40","gs","normal","116000");
goods[1525] =new setGoods("0000a58785","80","80","72","40","gs","normal","117000");
goods[1526] =new setGoods("0000a58786","90","90","72","40","gs","normal","138000");
goods[1527] =new setGoods("0000a58787","50","40","90","40","gs","normal","70000");
goods[1528] =new setGoods("0000a58788","60","40","90","40","gs","normal","70000");
goods[1529] =new setGoods("0000a58789","70","40","90","40","gs","normal","73000");
goods[1530] =new setGoods("0000a58790","80","40","90","40","gs","normal","74000");
goods[1531] =new setGoods("0000a58791","90","40","90","40","gs","normal","75000");
goods[1532] =new setGoods("0000a58792","100","40","90","40","gs","normal","86000");
goods[1533] =new setGoods("0000a58793","110","40","90","40","gs","normal","88000");
goods[1534] =new setGoods("0000a58794","120","40","90","40","gs","normal","91000");
goods[1535] =new setGoods("0000a58795","130","40","90","40","gs","normal","91000");
goods[1536] =new setGoods("0000a58796","140","40","90","40","gs","normal","92000");
goods[1537] =new setGoods("0000a58797","150","40","90","40","gs","normal","93000");
goods[1538] =new setGoods("0000a58798","60","50","90","40","gs","normal","103000");
goods[1539] =new setGoods("0000a58799","70","50","90","40","gs","normal","110000");
goods[1540] =new setGoods("0000a58800","80","50","90","40","gs","normal","111000");
goods[1541] =new setGoods("0000a58801","90","50","90","40","gs","normal","113000");
goods[1542] =new setGoods("0000a58802","100","50","90","40","gs","normal","132000");
goods[1543] =new setGoods("0000a58803","110","50","90","40","gs","normal","134000");
goods[1544] =new setGoods("0000a58804","120","50","90","40","gs","normal","138000");
goods[1545] =new setGoods("0000a58805","130","50","90","40","gs","normal","139000");
goods[1546] =new setGoods("0000a58806","140","50","90","40","gs","normal","139000");
goods[1547] =new setGoods("0000a58807","150","50","90","40","gs","normal","141000");
goods[1548] =new setGoods("0000a58808","70","60","90","40","gs","normal","114000");
goods[1549] =new setGoods("0000a58809","80","60","90","40","gs","normal","115000");
goods[1550] =new setGoods("0000a58810","90","60","90","40","gs","normal","116000");
goods[1551] =new setGoods("0000a58811","100","60","90","40","gs","normal","136000");
goods[1552] =new setGoods("0000a58812","110","60","90","40","gs","normal","138000");
goods[1553] =new setGoods("0000a58813","120","60","90","40","gs","normal","144000");
goods[1554] =new setGoods("0000a58814","130","60","90","40","gs","normal","144000");
goods[1555] =new setGoods("0000a58815","140","60","90","40","gs","normal","145000");
goods[1556] =new setGoods("0000a58816","150","60","90","40","gs","normal","145000");
goods[1557] =new setGoods("0000a58817","80","70","90","40","gs","normal","119000");
goods[1558] =new setGoods("0000a58818","90","70","90","40","gs","normal","127000");
goods[1559] =new setGoods("0000a58819","100","70","90","40","gs","normal","139000");
goods[1560] =new setGoods("0000a58820","110","70","90","40","gs","normal","143000");
goods[1561] =new setGoods("0000a58821","120","70","90","40","gs","normal","148000");
goods[1562] =new setGoods("0000a58822","130","70","90","40","gs","normal","148000");
goods[1563] =new setGoods("0000a58823","140","70","90","40","gs","normal","148000");
goods[1564] =new setGoods("0000a58824","150","70","90","40","gs","normal","149000");
goods[1565] =new setGoods("0000a58825","90","80","90","40","gs","normal","139000");
goods[1566] =new setGoods("0000a58826","100","80","90","40","gs","normal","141000");
goods[1567] =new setGoods("0000a58827","110","80","90","40","gs","normal","143000");
goods[1568] =new setGoods("0000a58828","120","80","90","40","gs","normal","148000");
goods[1569] =new setGoods("0000a58829","130","80","90","40","gs","normal","148000");
goods[1570] =new setGoods("0000a58830","140","80","90","40","gs","normal","149000");
goods[1571] =new setGoods("0000a58831","150","80","90","40","gs","normal","151000");
goods[1572] =new setGoods("0000a58832","100","90","90","40","gs","normal","142000");
goods[1573] =new setGoods("0000a58833","110","90","90","40","gs","normal","144000");
goods[1574] =new setGoods("0000a58834","120","90","90","40","gs","normal","148000");
goods[1575] =new setGoods("0000a58835","130","90","90","40","gs","normal","149000");
goods[1576] =new setGoods("0000a58836","140","90","90","40","gs","normal","151000");
goods[1577] =new setGoods("0000a58837","150","90","90","40","gs","normal","151000");
goods[1578] =new setGoods("0000a58838","40","40","90","40","gs","normal","65000");
goods[1579] =new setGoods("0000a58839","50","50","90","40","gs","normal","102000");
goods[1580] =new setGoods("0000a58840","60","60","90","40","gs","normal","106000");
goods[1581] =new setGoods("0000a58841","70","70","90","40","gs","normal","117000");
goods[1582] =new setGoods("0000a58842","80","80","90","40","gs","normal","119000");
goods[1583] =new setGoods("0000a58843","90","90","90","40","gs","normal","141000");
goods[1584] =new setGoods("0000a58844","40","30","42","40","ww","normal","38000");
goods[1585] =new setGoods("0000a58845","50","30","42","40","ww","normal","40000");
goods[1586] =new setGoods("0000a58846","60","30","42","40","ww","normal","40000");
goods[1587] =new setGoods("0000a58847","70","30","42","40","ww","normal","42000");
goods[1588] =new setGoods("0000a58848","80","30","42","40","ww","normal","43000");
goods[1589] =new setGoods("0000a58849","90","30","42","40","ww","normal","44000");
goods[1590] =new setGoods("0000a58850","100","30","42","40","ww","normal","51000");
goods[1591] =new setGoods("0000a58851","110","30","42","40","ww","normal","55000");
goods[1592] =new setGoods("0000a58852","120","30","42","40","ww","normal","58000");
goods[1593] =new setGoods("0000a58853","130","30","42","40","ww","normal","59000");
goods[1594] =new setGoods("0000a58854","140","30","42","40","ww","normal","59000");
goods[1595] =new setGoods("0000a58855","150","30","42","40","ww","normal","60000");
goods[1596] =new setGoods("0000a58856","50","40","42","40","ww","normal","50000");
goods[1597] =new setGoods("0000a58857","60","40","42","40","ww","normal","49000");
goods[1598] =new setGoods("0000a58858","70","40","42","40","ww","normal","53000");
goods[1599] =new setGoods("0000a58859","80","40","42","40","ww","normal","54000");
goods[1600] =new setGoods("0000a58860","90","40","42","40","ww","normal","55000");
goods[1601] =new setGoods("0000a58861","100","40","42","40","ww","normal","67000");
goods[1602] =new setGoods("0000a58862","110","40","42","40","ww","normal","69000");
goods[1603] =new setGoods("0000a58863","120","40","42","40","ww","normal","71000");
goods[1604] =new setGoods("0000a58864","130","40","42","40","ww","normal","72000");
goods[1605] =new setGoods("0000a58865","140","40","42","40","ww","normal","73000");
goods[1606] =new setGoods("0000a58866","150","40","42","40","ww","normal","73000");
goods[1607] =new setGoods("0000a58867","60","50","42","40","ww","normal","73000");
goods[1608] =new setGoods("0000a58868","70","50","42","40","ww","normal","77000");
goods[1609] =new setGoods("0000a58869","80","50","42","40","ww","normal","80000");
goods[1610] =new setGoods("0000a58870","90","50","42","40","ww","normal","82000");
goods[1611] =new setGoods("0000a58871","100","50","42","40","ww","normal","101000");
goods[1612] =new setGoods("0000a58872","110","50","42","40","ww","normal","103000");
goods[1613] =new setGoods("0000a58873","120","50","42","40","ww","normal","108000");
goods[1614] =new setGoods("0000a58874","130","50","42","40","ww","normal","109000");
goods[1615] =new setGoods("0000a58875","140","50","42","40","ww","normal","109000");
goods[1616] =new setGoods("0000a58876","150","50","42","40","ww","normal","110000");
goods[1617] =new setGoods("0000a58877","70","60","42","40","ww","normal","87000");
goods[1618] =new setGoods("0000a58878","80","60","42","40","ww","normal","89000");
goods[1619] =new setGoods("0000a58879","90","60","42","40","ww","normal","86000");
goods[1620] =new setGoods("0000a58880","100","60","42","40","ww","normal","105000");
goods[1621] =new setGoods("0000a58881","110","60","42","40","ww","normal","108000");
goods[1622] =new setGoods("0000a58882","120","60","42","40","ww","normal","113000");
goods[1623] =new setGoods("0000a58883","130","60","42","40","ww","normal","113000");
goods[1624] =new setGoods("0000a58884","140","60","42","40","ww","normal","114000");
goods[1625] =new setGoods("0000a58885","150","60","42","40","ww","normal","114000");
goods[1626] =new setGoods("0000a58886","80","70","42","40","ww","normal","91000");
goods[1627] =new setGoods("0000a58887","90","70","42","40","ww","normal","93000");
goods[1628] =new setGoods("0000a58888","100","70","42","40","ww","normal","108000");
goods[1629] =new setGoods("0000a58889","110","70","42","40","ww","normal","111000");
goods[1630] =new setGoods("0000a58890","120","70","42","40","ww","normal","116000");
goods[1631] =new setGoods("0000a58891","130","70","42","40","ww","normal","116000");
goods[1632] =new setGoods("0000a58892","140","70","42","40","ww","normal","116000");
goods[1633] =new setGoods("0000a58893","150","70","42","40","ww","normal","116000");
goods[1634] =new setGoods("0000a58894","90","80","42","40","ww","normal","93000");
goods[1635] =new setGoods("0000a58895","100","80","42","40","ww","normal","109000");
goods[1636] =new setGoods("0000a58896","110","80","42","40","ww","normal","111000");
goods[1637] =new setGoods("0000a58897","120","80","42","40","ww","normal","116000");
goods[1638] =new setGoods("0000a58898","130","80","42","40","ww","normal","116000");
goods[1639] =new setGoods("0000a58899","140","80","42","40","ww","normal","116000");
goods[1640] =new setGoods("0000a58900","150","80","42","40","ww","normal","120000");
goods[1641] =new setGoods("0000a58901","100","90","42","40","ww","normal","110000");
goods[1642] =new setGoods("0000a58902","110","90","42","40","ww","normal","112000");
goods[1643] =new setGoods("0000a58903","120","90","42","40","ww","normal","116000");
goods[1644] =new setGoods("0000a58904","130","90","42","40","ww","normal","116000");
goods[1645] =new setGoods("0000a58905","140","90","42","40","ww","normal","120000");
goods[1646] =new setGoods("0000a58906","150","90","42","40","ww","normal","120000");
goods[1647] =new setGoods("0000a58907","40","40","42","40","ww","normal","46000");
goods[1648] =new setGoods("0000a58908","50","50","42","40","ww","normal","70000");
goods[1649] =new setGoods("0000a58909","60","60","42","40","ww","normal","74000");
goods[1650] =new setGoods("0000a58910","70","70","42","40","ww","normal","86000");
goods[1651] =new setGoods("0000a58911","80","80","42","40","ww","normal","87000");
goods[1652] =new setGoods("0000a58912","90","90","42","40","ww","normal","103000");
goods[1653] =new setGoods("0000a58913","40","30","60","40","ww","normal","43000");
goods[1654] =new setGoods("0000a58914","50","30","60","40","ww","normal","46000");
goods[1655] =new setGoods("0000a58915","60","30","60","40","ww","normal","46000");
goods[1656] =new setGoods("0000a58916","70","30","60","40","ww","normal","48000");
goods[1657] =new setGoods("0000a58917","80","30","60","40","ww","normal","49000");
goods[1658] =new setGoods("0000a58918","90","30","60","40","ww","normal","50000");
goods[1659] =new setGoods("0000a58919","100","30","60","40","ww","normal","58000");
goods[1660] =new setGoods("0000a58920","110","30","60","40","ww","normal","60000");
goods[1661] =new setGoods("0000a58921","120","30","60","40","ww","normal","64000");
goods[1662] =new setGoods("0000a58922","130","30","60","40","ww","normal","65000");
goods[1663] =new setGoods("0000a58923","140","30","60","40","ww","normal","65000");
goods[1664] =new setGoods("0000a58924","150","30","60","40","ww","normal","66000");
goods[1665] =new setGoods("0000a58925","50","40","60","40","ww","normal","57000");
goods[1666] =new setGoods("0000a58926","60","40","60","40","ww","normal","55000");
goods[1667] =new setGoods("0000a58927","70","40","60","40","ww","normal","60000");
goods[1668] =new setGoods("0000a58928","80","40","60","40","ww","normal","61000");
goods[1669] =new setGoods("0000a58929","90","40","60","40","ww","normal","63000");
goods[1670] =new setGoods("0000a58930","100","40","60","40","ww","normal","73000");
goods[1671] =new setGoods("0000a58931","110","40","60","40","ww","normal","76000");
goods[1672] =new setGoods("0000a58932","120","40","60","40","ww","normal","79000");
goods[1673] =new setGoods("0000a58933","130","40","60","40","ww","normal","79000");
goods[1674] =new setGoods("0000a58934","140","40","60","40","ww","normal","80000");
goods[1675] =new setGoods("0000a58935","150","40","60","40","ww","normal","80000");
goods[1676] =new setGoods("0000a58936","60","50","60","40","ww","normal","84000");
goods[1677] =new setGoods("0000a58937","70","50","60","40","ww","normal","88000");
goods[1678] =new setGoods("0000a58938","80","50","60","40","ww","normal","91000");
goods[1679] =new setGoods("0000a58939","90","50","60","40","ww","normal","92000");
goods[1680] =new setGoods("0000a58940","100","50","60","40","ww","normal","112000");
goods[1681] =new setGoods("0000a58941","110","50","60","40","ww","normal","114000");
goods[1682] =new setGoods("0000a58942","120","50","60","40","ww","normal","117000");
goods[1683] =new setGoods("0000a58943","130","50","60","40","ww","normal","120000");
goods[1684] =new setGoods("0000a58944","140","50","60","40","ww","normal","120000");
goods[1685] =new setGoods("0000a58945","150","50","60","40","ww","normal","120000");
goods[1686] =new setGoods("0000a58946","70","60","60","40","ww","normal","98000");
goods[1687] =new setGoods("0000a58947","80","60","60","40","ww","normal","100000");
goods[1688] =new setGoods("0000a58948","90","60","60","40","ww","normal","97000");
goods[1689] =new setGoods("0000a58949","100","60","60","40","ww","normal","115000");
goods[1690] =new setGoods("0000a58950","110","60","60","40","ww","normal","117000");
goods[1691] =new setGoods("0000a58951","120","60","60","40","ww","normal","124000");
goods[1692] =new setGoods("0000a58952","130","60","60","40","ww","normal","124000");
goods[1693] =new setGoods("0000a58953","140","60","60","40","ww","normal","124000");
goods[1694] =new setGoods("0000a58954","150","60","60","40","ww","normal","125000");
goods[1695] =new setGoods("0000a58955","80","70","60","40","ww","normal","102000");
goods[1696] =new setGoods("0000a58956","90","70","60","40","ww","normal","104000");
goods[1697] =new setGoods("0000a58957","100","70","60","40","ww","normal","117000");
goods[1698] =new setGoods("0000a58958","110","70","60","40","ww","normal","119000");
goods[1699] =new setGoods("0000a58959","120","70","60","40","ww","normal","119000");
goods[1700] =new setGoods("0000a58960","130","70","60","40","ww","normal","119000");
goods[1701] =new setGoods("0000a58961","140","70","60","40","ww","normal","119000");
goods[1702] =new setGoods("0000a58962","150","70","60","40","ww","normal","119000");
goods[1703] =new setGoods("0000a58963","90","80","60","40","ww","normal","117000");
goods[1704] =new setGoods("0000a58964","100","80","60","40","ww","normal","119000");
goods[1705] =new setGoods("0000a58965","110","80","60","40","ww","normal","122000");
goods[1706] =new setGoods("0000a58966","120","80","60","40","ww","normal","127000");
goods[1707] =new setGoods("0000a58967","130","80","60","40","ww","normal","127000");
goods[1708] =new setGoods("0000a58968","140","80","60","40","ww","normal","128000");
goods[1709] =new setGoods("0000a58969","150","80","60","40","ww","normal","131000");
goods[1710] =new setGoods("0000a58970","100","90","60","40","ww","normal","121000");
goods[1711] =new setGoods("0000a58971","110","90","60","40","ww","normal","123000");
goods[1712] =new setGoods("0000a58972","120","90","60","40","ww","normal","127000");
goods[1713] =new setGoods("0000a58973","130","90","60","40","ww","normal","128000");
goods[1714] =new setGoods("0000a58974","140","90","60","40","ww","normal","131000");
goods[1715] =new setGoods("0000a58975","150","90","60","40","ww","normal","131000");
goods[1716] =new setGoods("0000a58976","40","40","60","40","ww","normal","52000");
goods[1717] =new setGoods("0000a58977","50","50","60","40","ww","normal","80000");
goods[1718] =new setGoods("0000a58978","60","60","60","40","ww","normal","85000");
goods[1719] =new setGoods("0000a58979","70","70","60","40","ww","normal","97000");
goods[1720] =new setGoods("0000a58980","80","80","60","40","ww","normal","98000");
goods[1721] =new setGoods("0000a58981","90","90","60","40","ww","normal","119000");
goods[1722] =new setGoods("0000a58982","40","30","72","40","ww","normal","52000");
goods[1723] =new setGoods("0000a58983","50","30","72","40","ww","normal","54000");
goods[1724] =new setGoods("0000a58984","60","30","72","40","ww","normal","54000");
goods[1725] =new setGoods("0000a58985","70","30","72","40","ww","normal","57000");
goods[1726] =new setGoods("0000a58986","80","30","72","40","ww","normal","58000");
goods[1727] =new setGoods("0000a58987","90","30","72","40","ww","normal","59000");
goods[1728] =new setGoods("0000a58988","100","30","72","40","ww","normal","66000");
goods[1729] =new setGoods("0000a58989","110","30","72","40","ww","normal","69000");
goods[1730] =new setGoods("0000a58990","120","30","72","40","ww","normal","72000");
goods[1731] =new setGoods("0000a58991","130","30","72","40","ww","normal","73000");
goods[1732] =new setGoods("0000a58992","140","30","72","40","ww","normal","73000");
goods[1733] =new setGoods("0000a58993","150","30","72","40","ww","normal","75000");
goods[1734] =new setGoods("0000a58994","50","40","72","40","ww","normal","68000");
goods[1735] =new setGoods("0000a58995","60","40","72","40","ww","normal","68000");
goods[1736] =new setGoods("0000a58996","70","40","72","40","ww","normal","71000");
goods[1737] =new setGoods("0000a58997","80","40","72","40","ww","normal","72000");
goods[1738] =new setGoods("0000a58998","90","40","72","40","ww","normal","74000");
goods[1739] =new setGoods("0000a58999","100","40","72","40","ww","normal","84000");
goods[1740] =new setGoods("0000a59000","110","40","72","40","ww","normal","87000");
goods[1741] =new setGoods("0000a59001","120","40","72","40","ww","normal","90000");
goods[1742] =new setGoods("0000a59002","130","40","72","40","ww","normal","90000");
goods[1743] =new setGoods("0000a59003","140","40","72","40","ww","normal","91000");
goods[1744] =new setGoods("0000a59004","150","40","72","40","ww","normal","92000");
goods[1745] =new setGoods("0000a59005","60","50","72","40","ww","normal","104000");
goods[1746] =new setGoods("0000a59006","70","50","72","40","ww","normal","107000");
goods[1747] =new setGoods("0000a59007","80","50","72","40","ww","normal","109000");
goods[1748] =new setGoods("0000a59008","90","50","72","40","ww","normal","112000");
goods[1749] =new setGoods("0000a59009","100","50","72","40","ww","normal","131000");
goods[1750] =new setGoods("0000a59010","110","50","72","40","ww","normal","133000");
goods[1751] =new setGoods("0000a59011","120","50","72","40","ww","normal","137000");
goods[1752] =new setGoods("0000a59012","130","50","72","40","ww","normal","138000");
goods[1753] =new setGoods("0000a59013","140","50","72","40","ww","normal","138000");
goods[1754] =new setGoods("0000a59014","150","50","72","40","ww","normal","139000");
goods[1755] =new setGoods("0000a59015","70","60","72","40","ww","normal","117000");
goods[1756] =new setGoods("0000a59016","80","60","72","40","ww","normal","119000");
goods[1757] =new setGoods("0000a59017","90","60","72","40","ww","normal","115000");
goods[1758] =new setGoods("0000a59018","100","60","72","40","ww","normal","135000");
goods[1759] =new setGoods("0000a59019","110","60","72","40","ww","normal","137000");
goods[1760] =new setGoods("0000a59020","120","60","72","40","ww","normal","143000");
goods[1761] =new setGoods("0000a59021","130","60","72","40","ww","normal","143000");
goods[1762] =new setGoods("0000a59022","140","60","72","40","ww","normal","144000");
goods[1763] =new setGoods("0000a59023","150","60","72","40","ww","normal","144000");
goods[1764] =new setGoods("0000a59024","80","70","72","40","ww","normal","122000");
goods[1765] =new setGoods("0000a59025","90","70","72","40","ww","normal","124000");
goods[1766] =new setGoods("0000a59026","100","70","72","40","ww","normal","137000");
goods[1767] =new setGoods("0000a59027","110","70","72","40","ww","normal","138000");
goods[1768] =new setGoods("0000a59028","120","70","72","40","ww","normal","138000");
goods[1769] =new setGoods("0000a59029","130","70","72","40","ww","normal","138000");
goods[1770] =new setGoods("0000a59030","140","70","72","40","ww","normal","138000");
goods[1771] =new setGoods("0000a59031","150","70","72","40","ww","normal","138000");
goods[1772] =new setGoods("0000a59032","90","80","72","40","ww","normal","137000");
goods[1773] =new setGoods("0000a59033","100","80","72","40","ww","normal","138000");
goods[1774] =new setGoods("0000a59034","110","80","72","40","ww","normal","142000");
goods[1775] =new setGoods("0000a59035","120","80","72","40","ww","normal","147000");
goods[1776] =new setGoods("0000a59036","130","80","72","40","ww","normal","147000");
goods[1777] =new setGoods("0000a59037","140","80","72","40","ww","normal","148000");
goods[1778] =new setGoods("0000a59038","150","80","72","40","ww","normal","150000");
goods[1779] =new setGoods("0000a59039","100","90","72","40","ww","normal","141000");
goods[1780] =new setGoods("0000a59040","110","90","72","40","ww","normal","143000");
goods[1781] =new setGoods("0000a59041","120","90","72","40","ww","normal","147000");
goods[1782] =new setGoods("0000a59042","130","90","72","40","ww","normal","148000");
goods[1783] =new setGoods("0000a59043","140","90","72","40","ww","normal","150000");
goods[1784] =new setGoods("0000a59044","150","90","72","40","ww","normal","150000");
goods[1785] =new setGoods("0000a59045","40","40","72","40","ww","normal","63000");
goods[1786] =new setGoods("0000a59046","50","50","72","40","ww","normal","99000");
goods[1787] =new setGoods("0000a59047","60","60","72","40","ww","normal","105000");
goods[1788] =new setGoods("0000a59048","70","70","72","40","ww","normal","116000");
goods[1789] =new setGoods("0000a59049","80","80","72","40","ww","normal","117000");
goods[1790] =new setGoods("0000a59050","90","90","72","40","ww","normal","138000");
goods[1791] =new setGoods("0000a59051","50","40","90","40","ww","normal","70000");
goods[1792] =new setGoods("0000a59052","60","40","90","40","ww","normal","70000");
goods[1793] =new setGoods("0000a59053","70","40","90","40","ww","normal","73000");
goods[1794] =new setGoods("0000a59054","80","40","90","40","ww","normal","74000");
goods[1795] =new setGoods("0000a59055","90","40","90","40","ww","normal","75000");
goods[1796] =new setGoods("0000a59056","100","40","90","40","ww","normal","86000");
goods[1797] =new setGoods("0000a59057","110","40","90","40","ww","normal","88000");
goods[1798] =new setGoods("0000a59058","120","40","90","40","ww","normal","91000");
goods[1799] =new setGoods("0000a59059","130","40","90","40","ww","normal","91000");
goods[1800] =new setGoods("0000a59060","140","40","90","40","ww","normal","92000");
goods[1801] =new setGoods("0000a59061","150","40","90","40","ww","normal","93000");
goods[1802] =new setGoods("0000a59062","60","50","90","40","ww","normal","103000");
goods[1803] =new setGoods("0000a59063","70","50","90","40","ww","normal","110000");
goods[1804] =new setGoods("0000a59064","80","50","90","40","ww","normal","111000");
goods[1805] =new setGoods("0000a59065","90","50","90","40","ww","normal","113000");
goods[1806] =new setGoods("0000a59066","100","50","90","40","ww","normal","132000");
goods[1807] =new setGoods("0000a59067","110","50","90","40","ww","normal","134000");
goods[1808] =new setGoods("0000a59068","120","50","90","40","ww","normal","138000");
goods[1809] =new setGoods("0000a59069","130","50","90","40","ww","normal","139000");
goods[1810] =new setGoods("0000a59070","140","50","90","40","ww","normal","139000");
goods[1811] =new setGoods("0000a59071","150","50","90","40","ww","normal","141000");
goods[1812] =new setGoods("0000a59072","70","60","90","40","ww","normal","114000");
goods[1813] =new setGoods("0000a59073","80","60","90","40","ww","normal","115000");
goods[1814] =new setGoods("0000a59074","90","60","90","40","ww","normal","116000");
goods[1815] =new setGoods("0000a59075","100","60","90","40","ww","normal","136000");
goods[1816] =new setGoods("0000a59076","110","60","90","40","ww","normal","138000");
goods[1817] =new setGoods("0000a59077","120","60","90","40","ww","normal","144000");
goods[1818] =new setGoods("0000a59078","130","60","90","40","ww","normal","144000");
goods[1819] =new setGoods("0000a59079","140","60","90","40","ww","normal","145000");
goods[1820] =new setGoods("0000a59080","150","60","90","40","ww","normal","145000");
goods[1821] =new setGoods("0000a59081","80","70","90","40","ww","normal","119000");
goods[1822] =new setGoods("0000a59082","90","70","90","40","ww","normal","127000");
goods[1823] =new setGoods("0000a59083","100","70","90","40","ww","normal","139000");
goods[1824] =new setGoods("0000a59084","110","70","90","40","ww","normal","143000");
goods[1825] =new setGoods("0000a59085","120","70","90","40","ww","normal","148000");
goods[1826] =new setGoods("0000a59086","130","70","90","40","ww","normal","148000");
goods[1827] =new setGoods("0000a59087","140","70","90","40","ww","normal","148000");
goods[1828] =new setGoods("0000a59088","150","70","90","40","ww","normal","149000");
goods[1829] =new setGoods("0000a59089","90","80","90","40","ww","normal","139000");
goods[1830] =new setGoods("0000a59090","100","80","90","40","ww","normal","141000");
goods[1831] =new setGoods("0000a59091","110","80","90","40","ww","normal","143000");
goods[1832] =new setGoods("0000a59092","120","80","90","40","ww","normal","148000");
goods[1833] =new setGoods("0000a59093","130","80","90","40","ww","normal","148000");
goods[1834] =new setGoods("0000a59094","140","80","90","40","ww","normal","149000");
goods[1835] =new setGoods("0000a59095","150","80","90","40","ww","normal","151000");
goods[1836] =new setGoods("0000a59096","100","90","90","40","ww","normal","142000");
goods[1837] =new setGoods("0000a59097","110","90","90","40","ww","normal","144000");
goods[1838] =new setGoods("0000a59098","120","90","90","40","ww","normal","148000");
goods[1839] =new setGoods("0000a59099","130","90","90","40","ww","normal","149000");
goods[1840] =new setGoods("0000a59100","140","90","90","40","ww","normal","151000");
goods[1841] =new setGoods("0000a59101","150","90","90","40","ww","normal","151000");
goods[1842] =new setGoods("0000a59102","40","40","90","40","ww","normal","65000");
goods[1843] =new setGoods("0000a59103","50","50","90","40","ww","normal","102000");
goods[1844] =new setGoods("0000a59104","60","60","90","40","ww","normal","106000");
goods[1845] =new setGoods("0000a59105","70","70","90","40","ww","normal","117000");
goods[1846] =new setGoods("0000a59106","80","80","90","40","ww","normal","119000");
goods[1847] =new setGoods("0000a59107","90","90","90","40","ww","normal","141000");
goods[1848] =new setGoods("未登録","40","30","42","40","kme","normal","48000");
goods[1849] =new setGoods("未登録","50","30","42","40","kme","normal","51000");
goods[1850] =new setGoods("未登録","60","30","42","40","kme","normal","51000");
goods[1851] =new setGoods("未登録","70","30","42","40","kme","normal","53000");
goods[1852] =new setGoods("未登録","80","30","42","40","kme","normal","55000");
goods[1853] =new setGoods("未登録","90","30","42","40","kme","normal","57000");
goods[1854] =new setGoods("未登録","100","30","42","40","kme","normal","65000");
goods[1855] =new setGoods("未登録","110","30","42","40","kme","normal","69000");
goods[1856] =new setGoods("未登録","120","30","42","40","kme","normal","73000");
goods[1857] =new setGoods("未登録","130","30","42","40","kme","normal","75000");
goods[1858] =new setGoods("未登録","140","30","42","40","kme","normal","75000");
goods[1859] =new setGoods("未登録","150","30","42","40","kme","normal","76000");
goods[1860] =new setGoods("未登録","50","40","42","40","kme","normal","63000");
goods[1861] =new setGoods("未登録","60","40","42","40","kme","normal","61000");
goods[1862] =new setGoods("未登録","70","40","42","40","kme","normal","67000");
goods[1863] =new setGoods("未登録","80","40","42","40","kme","normal","69000");
goods[1864] =new setGoods("未登録","90","40","42","40","kme","normal","70000");
goods[1865] =new setGoods("未登録","100","40","42","40","kme","normal","85000");
goods[1866] =new setGoods("未登録","110","40","42","40","kme","normal","87000");
goods[1867] =new setGoods("未登録","120","40","42","40","kme","normal","89000");
goods[1868] =new setGoods("未登録","130","40","42","40","kme","normal","91000");
goods[1869] =new setGoods("未登録","140","40","42","40","kme","normal","92000");
goods[1870] =new setGoods("未登録","150","40","42","40","kme","normal","92000");
goods[1871] =new setGoods("未登録","60","50","42","40","kme","normal","93000");
goods[1872] =new setGoods("未登録","70","50","42","40","kme","normal","97000");
goods[1873] =new setGoods("未登録","80","50","42","40","kme","normal","101000");
goods[1874] =new setGoods("未登録","90","50","42","40","kme","normal","104000");
goods[1875] =new setGoods("未登録","100","50","42","40","kme","normal","132000");
goods[1876] =new setGoods("未登録","110","50","42","40","kme","normal","132000");
goods[1877] =new setGoods("未登録","120","50","42","40","kme","normal","144000");
goods[1878] =new setGoods("未登録","130","50","42","40","kme","normal","145000");
goods[1879] =new setGoods("未登録","140","50","42","40","kme","normal","145000");
goods[1880] =new setGoods("未登録","150","50","42","40","kme","normal","145000");
goods[1881] =new setGoods("未登録","70","60","42","40","kme","normal","110000");
goods[1882] =new setGoods("未登録","80","60","42","40","kme","normal","112000");
goods[1883] =new setGoods("未登録","90","60","42","40","kme","normal","107000");
goods[1884] =new setGoods("未登録","100","60","42","40","kme","normal","132000");
goods[1885] =new setGoods("未登録","110","60","42","40","kme","normal","144000");
goods[1886] =new setGoods("未登録","120","60","42","40","kme","normal","145000");
goods[1887] =new setGoods("未登録","130","60","42","40","kme","normal","145000");
goods[1888] =new setGoods("未登録","140","60","42","40","kme","normal","145000");
goods[1889] =new setGoods("未登録","150","60","42","40","kme","normal","145000");
goods[1890] =new setGoods("未登録","80","70","42","40","kme","normal","115000");
goods[1891] =new setGoods("未登録","90","70","42","40","kme","normal","117000");
goods[1892] =new setGoods("未登録","100","70","42","40","kme","normal","144000");
goods[1893] =new setGoods("未登録","110","70","42","40","kme","normal","145000");
goods[1894] =new setGoods("未登録","120","70","42","40","kme","normal","145000");
goods[1895] =new setGoods("未登録","130","70","42","40","kme","normal","145000");
goods[1896] =new setGoods("未登録","140","70","42","40","kme","normal","145000");
goods[1897] =new setGoods("未登録","150","70","42","40","kme","normal","145000");
goods[1898] =new setGoods("未登録","90","80","42","40","kme","normal","117000");
goods[1899] =new setGoods("未登録","100","80","42","40","kme","normal","145000");
goods[1900] =new setGoods("未登録","110","80","42","40","kme","normal","145000");
goods[1901] =new setGoods("未登録","120","80","42","40","kme","normal","145000");
goods[1902] =new setGoods("未登録","130","80","42","40","kme","normal","145000");
goods[1903] =new setGoods("未登録","140","80","42","40","kme","normal","145000");
goods[1904] =new setGoods("未登録","150","80","42","40","kme","normal","159000");
goods[1905] =new setGoods("未登録","100","90","42","40","kme","normal","145000");
goods[1906] =new setGoods("未登録","110","90","42","40","kme","normal","145000");
goods[1907] =new setGoods("未登録","120","90","42","40","kme","normal","145000");
goods[1908] =new setGoods("未登録","130","90","42","40","kme","normal","145000");
goods[1909] =new setGoods("未登録","140","90","42","40","kme","normal","159000");
goods[1910] =new setGoods("未登録","150","90","42","40","kme","normal","159000");
goods[1911] =new setGoods("未登録","40","40","42","40","kme","normal","58000");
goods[1912] =new setGoods("未登録","50","50","42","40","kme","normal","88000");
goods[1913] =new setGoods("未登録","60","60","42","40","kme","normal","94000");
goods[1914] =new setGoods("未登録","70","70","42","40","kme","normal","107000");
goods[1915] =new setGoods("未登録","80","80","42","40","kme","normal","109000");
goods[1916] =new setGoods("未登録","90","90","42","40","kme","normal","133000");
goods[1917] =new setGoods("未登録","40","30","60","40","kme","normal","55000");
goods[1918] =new setGoods("未登録","50","30","60","40","kme","normal","58000");
goods[1919] =new setGoods("未登録","60","30","60","40","kme","normal","58000");
goods[1920] =new setGoods("未登録","70","30","60","40","kme","normal","60000");
goods[1921] =new setGoods("未登録","80","30","60","40","kme","normal","61000");
goods[1922] =new setGoods("未登録","90","30","60","40","kme","normal","63000");
goods[1923] =new setGoods("未登録","100","30","60","40","kme","normal","72000");
goods[1924] =new setGoods("未登録","110","30","60","40","kme","normal","76000");
goods[1925] =new setGoods("未登録","120","30","60","40","kme","normal","80000");
goods[1926] =new setGoods("未登録","130","30","60","40","kme","normal","81000");
goods[1927] =new setGoods("未登録","140","30","60","40","kme","normal","81000");
goods[1928] =new setGoods("未登録","150","30","60","40","kme","normal","82000");
goods[1929] =new setGoods("未登録","50","40","60","40","kme","normal","71000");
goods[1930] =new setGoods("未登録","60","40","60","40","kme","normal","70000");
goods[1931] =new setGoods("未登録","70","40","60","40","kme","normal","76000");
goods[1932] =new setGoods("未登録","80","40","60","40","kme","normal","77000");
goods[1933] =new setGoods("未登録","90","40","60","40","kme","normal","79000");
goods[1934] =new setGoods("未登録","100","40","60","40","kme","normal","93000");
goods[1935] =new setGoods("未登録","110","40","60","40","kme","normal","95000");
goods[1936] =new setGoods("未登録","120","40","60","40","kme","normal","99000");
goods[1937] =new setGoods("未登録","130","40","60","40","kme","normal","99000");
goods[1938] =new setGoods("未登録","140","40","60","40","kme","normal","100000");
goods[1939] =new setGoods("未登録","150","40","60","40","kme","normal","100000");
goods[1940] =new setGoods("未登録","60","50","60","40","kme","normal","106000");
goods[1941] =new setGoods("未登録","70","50","60","40","kme","normal","112000");
goods[1942] =new setGoods("未登録","80","50","60","40","kme","normal","114000");
goods[1943] =new setGoods("未登録","90","50","60","40","kme","normal","116000");
goods[1944] =new setGoods("未登録","100","50","60","40","kme","normal","144000");
goods[1945] =new setGoods("未登録","110","50","60","40","kme","normal","144000");
goods[1946] =new setGoods("未登録","120","50","60","40","kme","normal","156000");
goods[1947] =new setGoods("未登録","130","50","60","40","kme","normal","157000");
goods[1948] =new setGoods("未登録","140","50","60","40","kme","normal","157000");
goods[1949] =new setGoods("未登録","150","50","60","40","kme","normal","157000");
goods[1950] =new setGoods("未登録","70","60","60","40","kme","normal","131000");
goods[1951] =new setGoods("未登録","80","60","60","40","kme","normal","132000");
goods[1952] =new setGoods("未登録","90","60","60","40","kme","normal","122000");
goods[1953] =new setGoods("未登録","100","60","60","40","kme","normal","144000");
goods[1954] =new setGoods("未登録","110","60","60","40","kme","normal","156000");
goods[1955] =new setGoods("未登録","120","60","60","40","kme","normal","157000");
goods[1956] =new setGoods("未登録","130","60","60","40","kme","normal","157000");
goods[1957] =new setGoods("未登録","140","60","60","40","kme","normal","157000");
goods[1958] =new setGoods("未登録","150","60","60","40","kme","normal","157000");
goods[1959] =new setGoods("未登録","80","70","60","40","kme","normal","132000");
goods[1960] =new setGoods("未登録","90","70","60","40","kme","normal","132000");
goods[1961] =new setGoods("未登録","100","70","60","40","kme","normal","156000");
goods[1962] =new setGoods("未登録","110","70","60","40","kme","normal","157000");
goods[1963] =new setGoods("未登録","120","70","60","40","kme","normal","157000");
goods[1964] =new setGoods("未登録","130","70","60","40","kme","normal","157000");
goods[1965] =new setGoods("未登録","140","70","60","40","kme","normal","157000");
goods[1966] =new setGoods("未登録","150","70","60","40","kme","normal","157000");
goods[1967] =new setGoods("未登録","90","80","60","40","kme","normal","156000");
goods[1968] =new setGoods("未登録","100","80","60","40","kme","normal","157000");
goods[1969] =new setGoods("未登録","110","80","60","40","kme","normal","157000");
goods[1970] =new setGoods("未登録","120","80","60","40","kme","normal","169000");
goods[1971] =new setGoods("未登録","130","80","60","40","kme","normal","169000");
goods[1972] =new setGoods("未登録","140","80","60","40","kme","normal","169000");
goods[1973] =new setGoods("未登録","150","80","60","40","kme","normal","171000");
goods[1974] =new setGoods("未登録","100","90","60","40","kme","normal","157000");
goods[1975] =new setGoods("未登録","110","90","60","40","kme","normal","157000");
goods[1976] =new setGoods("未登録","120","90","60","40","kme","normal","169000");
goods[1977] =new setGoods("未登録","130","90","60","40","kme","normal","169000");
goods[1978] =new setGoods("未登録","140","90","60","40","kme","normal","171000");
goods[1979] =new setGoods("未登録","150","90","60","40","kme","normal","171000");
goods[1980] =new setGoods("未登録","40","40","60","40","kme","normal","66000");
goods[1981] =new setGoods("未登録","50","50","60","40","kme","normal","101000");
goods[1982] =new setGoods("未登録","60","60","60","40","kme","normal","107000");
goods[1983] =new setGoods("未登録","70","70","60","40","kme","normal","122000");
goods[1984] =new setGoods("未登録","80","80","60","40","kme","normal","132000");
goods[1985] =new setGoods("未登録","90","90","60","40","kme","normal","142000");
goods[1986] =new setGoods("未登録","40","30","72","40","kme","normal","66000");
goods[1987] =new setGoods("未登録","50","30","72","40","kme","normal","69000");
goods[1988] =new setGoods("未登録","60","30","72","40","kme","normal","69000");
goods[1989] =new setGoods("未登録","70","30","72","40","kme","normal","71000");
goods[1990] =new setGoods("未登録","80","30","72","40","kme","normal","73000");
goods[1991] =new setGoods("未登録","90","30","72","40","kme","normal","75000");
goods[1992] =new setGoods("未登録","100","30","72","40","kme","normal","84000");
goods[1993] =new setGoods("未登録","110","30","72","40","kme","normal","87000");
goods[1994] =new setGoods("未登録","120","30","72","40","kme","normal","91000");
goods[1995] =new setGoods("未登録","130","30","72","40","kme","normal","93000");
goods[1996] =new setGoods("未登録","140","30","72","40","kme","normal","93000");
goods[1997] =new setGoods("未登録","150","30","72","40","kme","normal","94000");
goods[1998] =new setGoods("未登録","50","40","72","40","kme","normal","85000");
goods[1999] =new setGoods("未登録","60","40","72","40","kme","normal","85000");
goods[2000] =new setGoods("未登録","70","40","72","40","kme","normal","89000");
goods[2001] =new setGoods("未登録","80","40","72","40","kme","normal","91000");
goods[2002] =new setGoods("未登録","90","40","72","40","kme","normal","94000");
goods[2003] =new setGoods("未登録","100","40","72","40","kme","normal","106000");
goods[2004] =new setGoods("未登録","110","40","72","40","kme","normal","109000");
goods[2005] =new setGoods("未登録","120","40","72","40","kme","normal","113000");
goods[2006] =new setGoods("未登録","130","40","72","40","kme","normal","113000");
goods[2007] =new setGoods("未登録","140","40","72","40","kme","normal","114000");
goods[2008] =new setGoods("未登録","150","40","72","40","kme","normal","116000");
goods[2009] =new setGoods("未登録","60","50","72","40","kme","normal","130000");
goods[2010] =new setGoods("未登録","70","50","72","40","kme","normal","142000");
goods[2011] =new setGoods("未登録","80","50","72","40","kme","normal","143000");
goods[2012] =new setGoods("未登録","90","50","72","40","kme","normal","144000");
goods[2013] =new setGoods("未登録","100","50","72","40","kme","normal","168000");
goods[2014] =new setGoods("未登録","110","50","72","40","kme","normal","168000");
goods[2015] =new setGoods("未登録","120","50","72","40","kme","normal","180000");
goods[2016] =new setGoods("未登録","130","50","72","40","kme","normal","181000");
goods[2017] =new setGoods("未登録","140","50","72","40","kme","normal","181000");
goods[2018] =new setGoods("未登録","150","50","72","40","kme","normal","181000");
goods[2019] =new setGoods("未登録","70","60","72","40","kme","normal","155000");
goods[2020] =new setGoods("未登録","80","60","72","40","kme","normal","156000");
goods[2021] =new setGoods("未登録","90","60","72","40","kme","normal","144000");
goods[2022] =new setGoods("未登録","100","60","72","40","kme","normal","168000");
goods[2023] =new setGoods("未登録","110","60","72","40","kme","normal","180000");
goods[2024] =new setGoods("未登録","120","60","72","40","kme","normal","181000");
goods[2025] =new setGoods("未登録","130","60","72","40","kme","normal","181000");
goods[2026] =new setGoods("未登録","140","60","72","40","kme","normal","181000");
goods[2027] =new setGoods("未登録","150","60","72","40","kme","normal","181000");
goods[2028] =new setGoods("未登録","80","70","72","40","kme","normal","156000");
goods[2029] =new setGoods("未登録","90","70","72","40","kme","normal","156000");
goods[2030] =new setGoods("未登録","100","70","72","40","kme","normal","180000");
goods[2031] =new setGoods("未登録","110","70","72","40","kme","normal","181000");
goods[2032] =new setGoods("未登録","120","70","72","40","kme","normal","181000");
goods[2033] =new setGoods("未登録","130","70","72","40","kme","normal","181000");
goods[2034] =new setGoods("未登録","140","70","72","40","kme","normal","181000");
goods[2035] =new setGoods("未登録","150","70","72","40","kme","normal","181000");
goods[2036] =new setGoods("未登録","90","80","72","40","kme","normal","180000");
goods[2037] =new setGoods("未登録","100","80","72","40","kme","normal","181000");
goods[2038] =new setGoods("未登録","110","80","72","40","kme","normal","181000");
goods[2039] =new setGoods("未登録","120","80","72","40","kme","normal","193000");
goods[2040] =new setGoods("未登録","130","80","72","40","kme","normal","193000");
goods[2041] =new setGoods("未登録","140","80","72","40","kme","normal","193000");
goods[2042] =new setGoods("未登録","150","80","72","40","kme","normal","195000");
goods[2043] =new setGoods("未登録","100","90","72","40","kme","normal","181000");
goods[2044] =new setGoods("未登録","110","90","72","40","kme","normal","181000");
goods[2045] =new setGoods("未登録","120","90","72","40","kme","normal","193000");
goods[2046] =new setGoods("未登録","130","90","72","40","kme","normal","193000");
goods[2047] =new setGoods("未登録","140","90","72","40","kme","normal","195000");
goods[2048] =new setGoods("未登録","150","90","72","40","kme","normal","195000");
goods[2049] =new setGoods("未登録","40","40","72","40","kme","normal","79000");
goods[2050] =new setGoods("未登録","50","50","72","40","kme","normal","130000");
goods[2051] =new setGoods("未登録","60","60","72","40","kme","normal","131000");
goods[2052] =new setGoods("未登録","70","70","72","40","kme","normal","156000");
goods[2053] =new setGoods("未登録","80","80","72","40","kme","normal","156000");
goods[2054] =new setGoods("未登録","90","90","72","40","kme","normal","165000");
goods[2055] =new setGoods("未登録","50","40","90","40","kme","normal","88000");
goods[2056] =new setGoods("未登録","60","40","90","40","kme","normal","88000");
goods[2057] =new setGoods("未登録","70","40","90","40","kme","normal","92000");
goods[2058] =new setGoods("未登録","80","40","90","40","kme","normal","94000");
goods[2059] =new setGoods("未登録","90","40","90","40","kme","normal","95000");
goods[2060] =new setGoods("未登録","100","40","90","40","kme","normal","107000");
goods[2061] =new setGoods("未登録","110","40","90","40","kme","normal","111000");
goods[2062] =new setGoods("未登録","120","40","90","40","kme","normal","115000");
goods[2063] =new setGoods("未登録","130","40","90","40","kme","normal","115000");
goods[2064] =new setGoods("未登録","140","40","90","40","kme","normal","116000");
goods[2065] =new setGoods("未登録","150","40","90","40","kme","normal","117000");
goods[2066] =new setGoods("未登録","60","50","90","40","kme","normal","132000");
goods[2067] =new setGoods("未登録","70","50","90","40","kme","normal","144000");
goods[2068] =new setGoods("未登録","80","50","90","40","kme","normal","144000");
goods[2069] =new setGoods("未登録","90","50","90","40","kme","normal","144000");
goods[2070] =new setGoods("未登録","100","50","90","40","kme","normal","168000");
goods[2071] =new setGoods("未登録","110","50","90","40","kme","normal","168000");
goods[2072] =new setGoods("未登録","120","50","90","40","kme","normal","180000");
goods[2073] =new setGoods("未登録","130","50","90","40","kme","normal","181000");
goods[2074] =new setGoods("未登録","140","50","90","40","kme","normal","181000");
goods[2075] =new setGoods("未登録","150","50","90","40","kme","normal","181000");
goods[2076] =new setGoods("未登録","70","60","90","40","kme","normal","144000");
goods[2077] =new setGoods("未登録","80","60","90","40","kme","normal","144000");
goods[2078] =new setGoods("未登録","90","60","90","40","kme","normal","156000");
goods[2079] =new setGoods("未登録","100","60","90","40","kme","normal","180000");
goods[2080] =new setGoods("未登録","110","60","90","40","kme","normal","180000");
goods[2081] =new setGoods("未登録","120","60","90","40","kme","normal","181000");
goods[2082] =new setGoods("未登録","130","60","90","40","kme","normal","181000");
goods[2083] =new setGoods("未登録","140","60","90","40","kme","normal","181000");
goods[2084] =new setGoods("未登録","150","60","90","40","kme","normal","181000");
goods[2085] =new setGoods("未登録","80","70","90","40","kme","normal","156000");
goods[2086] =new setGoods("未登録","90","70","90","40","kme","normal","150000");
goods[2087] =new setGoods("未登録","100","70","90","40","kme","normal","180000");
goods[2088] =new setGoods("未登録","110","70","90","40","kme","normal","181000");
goods[2089] =new setGoods("未登録","120","70","90","40","kme","normal","193000");
goods[2090] =new setGoods("未登録","130","70","90","40","kme","normal","193000");
goods[2091] =new setGoods("未登録","140","70","90","40","kme","normal","193000");
goods[2092] =new setGoods("未登録","150","70","90","40","kme","normal","193000");
goods[2093] =new setGoods("未登録","90","80","90","40","kme","normal","165000");
goods[2094] =new setGoods("未登録","100","80","90","40","kme","normal","181000");
goods[2095] =new setGoods("未登録","110","80","90","40","kme","normal","181000");
goods[2096] =new setGoods("未登録","120","80","90","40","kme","normal","193000");
goods[2097] =new setGoods("未登録","130","80","90","40","kme","normal","193000");
goods[2098] =new setGoods("未登録","140","80","90","40","kme","normal","193000");
goods[2099] =new setGoods("未登録","150","80","90","40","kme","normal","195000");
goods[2100] =new setGoods("未登録","100","90","90","40","kme","normal","181000");
goods[2101] =new setGoods("未登録","110","90","90","40","kme","normal","181000");
goods[2102] =new setGoods("未登録","120","90","90","40","kme","normal","193000");
goods[2103] =new setGoods("未登録","130","90","90","40","kme","normal","193000");
goods[2104] =new setGoods("未登録","140","90","90","40","kme","normal","195000");
goods[2105] =new setGoods("未登録","150","90","90","40","kme","normal","195000");
goods[2106] =new setGoods("未登録","40","40","90","40","kme","normal","82000");
goods[2107] =new setGoods("未登録","50","50","90","40","kme","normal","132000");
goods[2108] =new setGoods("未登録","60","60","90","40","kme","normal","132000");
goods[2109] =new setGoods("未登録","70","70","90","40","kme","normal","156000");
goods[2110] =new setGoods("未登録","80","80","90","40","kme","normal","156000");
goods[2111] =new setGoods("未登録","90","90","90","40","kme","normal","166000");